// ─── 00-hutech-lib.js ───
// HUTECH Canvas — Shared library (DOM helpers, i18n catalog, common utilities)
// File: 00-hutech-lib.js  (prefix 00- để load FIRST trong concat order alpha-sort)
//
// Exports vào `window.HUTECH.*` namespace:
//   - HUTECH.dom.{h, t, empty, replace}   — XSS-safe DOM API
//   - HUTECH.i18n.{t, locale, catalog}    — i18n catalog with {{params}}
//
// Build pipeline (build.mjs) inject i18n catalog vào placeholder
// `/* __HUTECH_I18N_CATALOG__ */`. Source: i18n/vi.json.

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) return;

  window.HUTECH = window.HUTECH || {};

  // === HUTECH.dom ===
  window.HUTECH.dom = {
    /**
     * Create element với attrs + children. XSS-safe (text children dùng
     * textContent, không innerHTML).
     *
     * @param {string} tag - tag name (vd. 'div', 'button')
     * @param {Object} [attrs] - attributes (class, style, data-*, aria-*, on<Event>)
     * @param {Array} [children] - nodes hoặc strings (string → text node)
     */
    h(tag, attrs, children) {
      const el = document.createElement(tag);
      if (attrs) {
        for (const k in attrs) {
          if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
          const v = attrs[k];
          if (v == null || v === false) continue;
          if (k === 'class' || k === 'className') {
            el.className = v;
          } else if (k === 'style' && typeof v === 'object') {
            Object.assign(el.style, v);
          } else if (k.startsWith('on') && typeof v === 'function') {
            el.addEventListener(k.slice(2).toLowerCase(), v);
          } else {
            el.setAttribute(k, v === true ? '' : String(v));
          }
        }
      }
      if (children) {
        for (let i = 0; i < children.length; i++) {
          const c = children[i];
          if (c == null || c === false) continue;
          el.appendChild(typeof c === 'string' || typeof c === 'number'
            ? document.createTextNode(String(c))
            : c);
        }
      }
      return el;
    },

    /** Tạo text node — dùng khi mix với elements */
    t(text) {
      return document.createTextNode(String(text == null ? '' : text));
    },

    /** Empty element (remove all children) */
    empty(el) {
      if (!el) return el;
      while (el.firstChild) el.removeChild(el.firstChild);
      return el;
    },

    /** Replace element children với new nodes (string → text node).
     *  KHÔNG dùng `this.empty()` — destructure `const { replace } = HUTECH.dom`
     *  sẽ mất binding `this`. Inline logic để safe khi destructured. */
    replace(el, ...nodes) {
      if (!el) return el;
      while (el.firstChild) el.removeChild(el.firstChild);
      for (const n of nodes) {
        if (n != null) el.appendChild(typeof n === 'string' ? document.createTextNode(n) : n);
      }
      return el;
    },
  };

  // === HUTECH.i18n ===
  // Catalog injected by build.mjs từ i18n/vi.json. Placeholder thay thế khi build.
  const CATALOG = {
  "lib.loaded": "HUTECH lib loaded — HUTECH.dom + HUTECH.i18n available",
  "lib.disabled": "Custom JS disabled via kill switch",

  "f2.skip.noRoles": "no current_user_roles in ENV — skip role tag",

  "f3.search.placeholder": "Tìm theo tên môn, mã môn, biệt danh…",
  "f3.search.label": "Tìm kiếm khóa học",
  "f3.search.clear": "Xóa từ khóa",
  "f3.filter.term.all": "Học kì: Tất cả",
  "f3.filter.term.prefix": "Học kì",
  "f3.filter.term.label": "Lọc theo học kì",
  "f3.filter.role.all": "Vai trò: Tất cả",
  "f3.filter.role.prefix": "Vai trò",
  "f3.filter.role.label": "Lọc theo vai trò",
  "f3.filter.fav.label": "⭐ Yêu thích",
  "f3.filter.fav.tooltip": "Chỉ hiện khóa học đã đánh dấu sao",
  "f3.filter.reset": "Reset",
  "f3.filter.reset.tooltip": "Xóa toàn bộ bộ lọc",
  "f3.status.total": "Tổng: {{total}} khóa học",
  "f3.status.shown": "Hiển thị {{visible}} / {{total}} khóa học",
  "f3.status.empty": "Không tìm thấy khóa học phù hợp {{desc}} · ",
  "f3.status.inlineReset": "Xóa bộ lọc",
  "f3.desc.with": "với",
  "f3.desc.keyword": "từ khóa \"{{q}}\"",
  "f3.desc.term": "Học Kì \"{{term}}\"",
  "f3.desc.role": "Vai trò \"{{role}}\"",
  "f3.desc.fav": "chỉ Yêu thích",

  "f4.nav.label": "Tổng quan nộp bài",
  "f4.modal.title": "Tổng quan nộp bài",
  "f4.modal.close.aria": "Đóng (ESC)",
  "f4.assignment.label": "Assignment: ",
  "f4.assignment.placeholder": "-- Chọn Assignment --",
  "f4.assignment.loading": "Đang tải...",
  "f4.assignment.error": "Lỗi tải assignments",
  "f4.assignment.due": " — hạn {{date}}",
  "f4.refresh.label": "↻ Làm mới",
  "f4.refresh.tooltip": "Bỏ cache + tải lại",
  "f4.stats.total": "Tổng SV",
  "f4.stats.submitted": "Đã nộp",
  "f4.stats.late": "Nộp trễ",
  "f4.stats.unsubmitted": "Chưa nộp",
  "f4.stats.graded": "Đã chấm",
  "f4.stats.progress": "{{pct}}% đã nộp",
  "f4.table.header.no": "#",
  "f4.table.header.name": "Họ tên",
  "f4.table.header.sis": "Mã SV",
  "f4.table.header.status": "Trạng thái",
  "f4.table.header.submittedAt": "Thời gian nộp",
  "f4.table.header.attachments": "File đính kèm",
  "f4.table.header.score": "Điểm",
  "f4.table.speedgrader": "SpeedGrader",
  "f4.table.header.select": "Chọn",
  "f4.table.header.download": "Tải",
  "f4.table.download.single": "Tải file SV",
  "f4.table.download.singleAria": "Tải tất cả file của {{name}}",
  "f4.bulk.selected": "{{count}} đã chọn",
  "f4.bulk.download": "↓ Tải file ({{count}})",
  "f4.bulk.downloadAll": "↓ Tải tất cả",
  "f4.bulk.selectAll": "Chọn tất cả đã nộp",
  "f4.bulk.zipping": "Đang nén... ({{done}}/{{total}})",
  "f4.bulk.zipError": "Lỗi tải/nén file: {{message}}",
  "f4.bulk.zipFilename": "{{assignment}}-submissions.zip",
  "f4.bulk.studentNoFiles": "{{name}}: chưa có file",
  "f4.empty.noAssignment": "Chọn Assignment để xem danh sách bài nộp.",
  "f4.empty.noStudents": "Course chưa có sinh viên enroll vào Assignment này.",
  "f4.dash": "—",
  "f4.error.loadSubmissions": "Lỗi tải submissions: {{message}}",
  "f4.status.graded": "Đã chấm",
  "f4.status.late": "Nộp trễ",
  "f4.status.submitted": "Đã nộp",
  "f4.status.unsubmitted": "Chưa nộp",

  "brand.footerCopyright": "© Trường Đại học Công nghệ TP.HCM (HUTECH)",
  "brand.loginWelcome": "Chào mừng bạn đến với HUTECH LMS",

  "login.title": "Đăng nhập HUTECH LMS",
  "login.subtitle": "Hệ thống quản lý học tập",
  "login.divider": "hoặc đăng nhập bằng",
  "login.pwd.show": "Hiện mật khẩu",
  "login.pwd.hide": "Ẩn mật khẩu",

  "pdf.fallback.title": "Tài liệu PDF",
  "pdf.fallback.message": "Trình duyệt không hiển thị được PDF inline.",
  "pdf.fallback.open": "Mở trong tab mới",
  "pdf.fallback.download": "Tải xuống",

  "xlsx.menu.label": "Xuất toàn bộ sổ điểm ra Excel",
  "xlsx.menu.exporting": "Đang xuất Excel...",
  "xlsx.menu.error": "Lỗi — bấm lại để thử"
};

  window.HUTECH.i18n = {
    /** Current locale code (chỉ 'vi' cho HUTECH MVP; future có thể detect từ ENV.LOCALE) */
    locale: 'vi',

    /** Catalog raw access (debug / inspection) */
    catalog: CATALOG,

    /**
     * Translate key với optional params interpolation `{{name}}`.
     * Missing key fallback về chính key + console.warn.
     *
     * @param {string} key - dotted key (vd. 'f4.nav.label')
     * @param {Object} [params] - interpolation values
     * @returns {string}
     */
    t(key, params) {
      let str = CATALOG[key];
      if (str === undefined) {
        console.warn('[HUTECH-i18n] missing key:', key);
        return key;
      }
      if (params) {
        for (const k in params) {
          if (!Object.prototype.hasOwnProperty.call(params, k)) continue;
          str = str.replace(new RegExp('\\{\\{' + k + '\\}\\}', 'g'), String(params[k]));
        }
      }
      return str;
    },
  };

  console.log('[HUTECH-lib]', window.HUTECH.i18n.t('lib.loaded'));
})();

// ─── chatbot-eduteam.js ───
// HUTECH — Trợ lý AI: nhúng chatbot bubble nổi.
// Khôi phục từ js_overrides cũ (accounts/1/files/24 = chatbot.js) bị thay khi
// chuyển brand_config sang bundle hutech-master.js. Nay bake thẳng vào bundle.
//
// Kill switch: ?disable_hutech_js=1 (chung toàn bộ Custom JS HUTECH).
(function () {
  'use strict';
  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) return;
  if (window.__hutechChatbotLoaded) return;
  window.__hutechChatbotLoaded = true;
  var s = document.createElement('script');
  s.src = 'https://chatbot.eduteam.vn/static/canvas-bubble.js';
  s.defer = true;
  s.onerror = function () { console.warn('[HUTECH-chatbot] không tải được canvas-bubble.js'); };
  document.head.appendChild(s);
})();

// ─── f2-navigation.js ───
// HUTECH Canvas — F2 Navigation Custom JS
// File: f2-navigation.js
// Refs: Issue #14 (F2b role-based), #15 (F2c notification badge — phase 2)
//
// Phase 1 (F2b):
//   - Tag body class theo user role primary
//   - CSS f2-navigation.css dùng class này để conditional hide
//
// Kill switch: ?disable_hutech_js=1
//
// Source: infra/customization/custom-js/f2-navigation.js

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) {
    console.log('[HUTECH-F2] disabled via kill switch');
    return;
  }

  const TAG = '[HUTECH-F2]';

  // --- F2b: Tag body class by user role ---
  // Source of truth: window.ENV.current_user_roles (Canvas inject sớm)
  // Mapping:
  //   admin / account_admin / root_admin → .hutech-role-admin
  //   teacher                             → .hutech-role-teacher
  //   student                             → .hutech-role-student
  //   observer                            → .hutech-role-observer
  //
  // Logic: nếu user có nhiều role, ưu tiên cao nhất (admin > teacher > student > observer)
  // Tính role ưu tiên cao nhất từ ENV.current_user_roles (null nếu thiếu).
  function computeRole() {
    const roles = (window.ENV && window.ENV.current_user_roles) || [];
    if (!Array.isArray(roles) || roles.length === 0) return null;
    if (
      roles.includes('admin') || roles.includes('account_admin') ||
      roles.includes('root_admin') || roles.includes('siteadmin')
    ) return 'admin';
    if (roles.includes('teacher')) return 'teacher';
    if (roles.includes('ta')) return 'ta';
    if (roles.includes('designer')) return 'designer';
    if (roles.includes('observer')) return 'observer';
    if (roles.includes('student') || roles.includes('user')) return 'student';
    return null;
  }

  function tagBodyByRole() {
    if (!document.body) return;
    if (document.body.classList.contains('hutech-role-tagged')) return;
    const role = computeRole();
    if (role) {
      document.body.classList.add('hutech-role-' + role);
      document.body.classList.add('hutech-role-tagged');
      console.log(TAG, 'tagged body.hutech-role-' + role);
    }
  }

  // --- Ẩn menu chỉ-sinh-viên với vai trò quản lý ---
  // Canvas course_navigation chỉ có visibility members/admins/public — KHÔNG có
  // "student-only". Tool "Insider Sinh viên" đặt members (SV+GV+admin đều thấy)
  // → ẩn phía client cho staff. Nhận diện staff BỀN (không chỉ dựa ENV role):
  // role≠student HOẶC thấy tool giảng viên (admins-only "Insider giảng viên") trong nav.
  const STUDENT_ONLY_LABELS = ['Insider Sinh viên'];
  const STAFF_TOOL_LABELS = ['Insider giảng viên'];
  function navLinks() {
    const sel = '#section-tabs a, .ic-app-course-menu a, #left-side a, nav[aria-label] a';
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }
  function matchesAny(text, labels) {
    return labels.some(function (l) { return text.indexOf(l) !== -1; });
  }
  function isStaff(role) {
    if (role && role !== 'student') return true;
    // fallback: thấy tool giảng viên (admins-only) trong nav = staff (kể cả khi ENV role lệch)
    return navLinks().some(function (a) {
      return matchesAny((a.textContent || '').trim(), STAFF_TOOL_LABELS);
    });
  }
  function hideStudentOnlyNav() {
    if (!isStaff(computeRole())) return; // SV thuần: giữ nguyên
    navLinks().forEach(function (a) {
      if (matchesAny((a.textContent || '').trim(), STUDENT_ONLY_LABELS)) {
        const li = a.closest('li') || a;
        li.style.setProperty('display', 'none', 'important');
        li.setAttribute('data-hutech-hidden', 'student-only');
      }
    });
  }

  // --- Run ---
  function run() {
    tagBodyByRole();
    hideStudentOnlyNav();
  }
  if (document.body) run();
  else document.addEventListener('DOMContentLoaded', run);
  // nav render trễ / SPA re-init → quét lại nhiều lần (không phụ thuộc role tag)
  [300, 800, 1600, 3000].forEach(function (ms) { setTimeout(hideStudentOnlyNav, ms); });

  // Re-run on SPA route change (Canvas may re-init ENV/nav on some navs)
  const _push = history.pushState;
  history.pushState = function () {
    _push.apply(history, arguments);
    setTimeout(run, 200);
    setTimeout(hideStudentOnlyNav, 900);
  };
  window.addEventListener('popstate', function () { setTimeout(run, 200); setTimeout(hideStudentOnlyNav, 900); });

  console.log(TAG, 'F2 navigation customization loaded');
})();

// ─── f3-courses-search.js ───
// HUTECH Canvas — F3 Courses Search + Filter Custom JS
// File: f3-courses-search.js
// Refs: Issue #37 — Tìm kiếm + Lọc Khóa Học trang /courses
//
// Features:
//   - URL: /courses (exact)
//   - Search input: real-time, debounce 200ms, diacritic-insensitive
//     Match: tên môn, mã môn, biệt danh, term name, role name
//   - Filter: Học Kì dropdown (mặc định "Tất cả" — không auto-filter)
//   - Filter: Vai trò dropdown (mặc định "Tất cả")
//   - Filter: ⭐ Yêu thích toggle chip
//   - Reset button xóa toàn bộ filter
//   - URL state sync: ?q=luat&term=HK2&role=teacher&fav=1 (persist khi share/refresh)
//
// Phase 3 (later, nếu cần):
//   - Sort column indicator (Canvas đã có server sort, chỉ thiếu visual)
//   - Empty state với link suggestion
//
// Kill switch: ?disable_hutech_js=1
// Source: infra/customization/custom-js/f3-courses-search.js

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) {
    console.log('[HUTECH-F3] disabled via kill switch');
    return;
  }

  // URL match: /courses exact (no /courses/<id>)
  if (!/^\/courses\/?$/.test(window.location.pathname)) return;

  const TAG = '[HUTECH-F3]';
  const PANEL_ID = 'hutech-courses-filter';
  console.log(TAG, 'init on /courses');

  // --- Unicode diacritic strip (Vietnamese-aware) ---
  function normalize(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/\p{M}/gu, '')
      .replace(/đ/g, 'd');
  }

  // (Phase 2.1: escapeHtml removed — HUTECH.dom textContent auto-escape)

  // --- Row data extraction ---
  function getCell(tr, cls) {
    const el = tr.querySelector('.course-list-' + cls + '-column');
    return el ? (el.textContent || '').trim() : '';
  }

  function isFavorited(tr) {
    return !!tr.querySelector('.course-list-favorite-course');
  }

  function buildRowData(tr) {
    const name = getCell(tr, 'course-title');
    const nickname = getCell(tr, 'nickname');
    const term = getCell(tr, 'term');
    const role = getCell(tr, 'enrolled-as');
    return {
      tr,
      name, nickname, term, role,
      favorited: isFavorited(tr),
      searchText: normalize([name, nickname, term, role].join(' '))
    };
  }

  // --- URL state ---
  function readState() {
    const p = new URLSearchParams(window.location.search);
    return {
      q: p.get('q') || '',
      term: p.get('term') || '',  // empty = all
      role: p.get('role') || '',
      fav: p.get('fav') === '1'
    };
  }

  function writeState(state) {
    const p = new URLSearchParams(window.location.search);
    state.q ? p.set('q', state.q) : p.delete('q');
    state.term ? p.set('term', state.term) : p.delete('term');
    state.role ? p.set('role', state.role) : p.delete('role');
    state.fav ? p.set('fav', '1') : p.delete('fav');
    const qs = p.toString();
    const newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState(null, '', newUrl);
  }

  // Format term name to short form for display only — giữ original làm value
  // "Học Kỳ 1 2025 - 2026" → "HK 1 2025-2026"
  // " Học Kỳ 2 2025 - 2026" → "HK 2 2025-2026"
  function formatTermDisplay(raw) {
    return raw
      .trim()
      .replace(/Học\s*Kỳ\s*/i, 'HK ')
      .replace(/\s*-\s*/g, '-');
  }

  // Canvas Default Term — courses không gán cho HK thực sự (sandbox admin).
  // KHÔNG đưa vào dropdown options (nhưng vẫn cho phép search + hiện ở "Tất cả").
  function isDefaultTerm(raw) {
    const n = normalize(raw);
    return n.includes('default') || n.includes('mac dinh');
  }

  // --- Render UI ---
  function buildPanel(rows, state) {
    const { h } = window.HUTECH.dom;
    const { t: i18n } = window.HUTECH.i18n;
    const terms = [...new Set(rows.map(r => r.term).filter(Boolean))]
      .filter(t => !isDefaultTerm(t))   // hide Default Term from dropdown
      .sort((a, b) => b.localeCompare(a, 'vi'));
    const roles = [...new Set(rows.map(r => r.role).filter(Boolean))]
      .sort((a, b) => a.localeCompare(b, 'vi'));

    const termOptions = [
      h('option', { value: '' }, [i18n('f3.filter.term.all')]),
      ...terms.map(term => h('option', {
        value: term, selected: state.term === term ? '' : null,
      }, [`${i18n('f3.filter.term.prefix')}: ${formatTermDisplay(term)}`])),
    ];

    const roleOptions = [
      h('option', { value: '' }, [i18n('f3.filter.role.all')]),
      ...roles.map(r => h('option', {
        value: r, selected: state.role === r ? '' : null,
      }, [`${i18n('f3.filter.role.prefix')}: ${r}`])),
    ];

    const searchInput = h('input', {
      type: 'search', id: 'hutech-courses-search', class: 'hutech-courses-filter__input',
      placeholder: i18n('f3.search.placeholder'),
      autocomplete: 'off', 'aria-label': i18n('f3.search.label'),
      value: state.q || '',
    });

    const favClass = 'hutech-courses-filter__chip' + (state.fav ? ' hutech-courses-filter__chip--active' : '');

    return h('div', { id: PANEL_ID, class: 'hutech-courses-filter' }, [
      h('div', { class: 'hutech-courses-filter__main' }, [
        h('div', { class: 'hutech-courses-filter__search-wrap' }, [
          h('span', { class: 'hutech-courses-filter__icon' }, ['🔍']),
          searchInput,
          h('button', {
            type: 'button', class: 'hutech-courses-filter__clear-search',
            'aria-label': i18n('f3.search.clear'), title: i18n('f3.search.clear'),
          }, ['✕']),
        ]),
        h('div', { class: 'hutech-courses-filter__controls' }, [
          h('select', {
            class: 'hutech-courses-filter__select', 'data-filter': 'term',
            'aria-label': i18n('f3.filter.term.label'),
          }, termOptions),
          h('select', {
            class: 'hutech-courses-filter__select', 'data-filter': 'role',
            'aria-label': i18n('f3.filter.role.label'),
          }, roleOptions),
          h('button', {
            type: 'button', class: favClass, 'data-filter': 'fav',
            'aria-pressed': String(state.fav),
            title: i18n('f3.filter.fav.tooltip'),
          }, [i18n('f3.filter.fav.label')]),
          h('button', {
            type: 'button', class: 'hutech-courses-filter__reset',
            title: i18n('f3.filter.reset.tooltip'),
          }, [i18n('f3.filter.reset')]),
        ]),
      ]),
      h('div', {
        class: 'hutech-courses-filter__status', role: 'status', 'aria-live': 'polite',
      }),
    ]);
  }

  // --- Filter apply ---
  function applyFilters(rows, state) {
    const q = normalize(state.q.trim());
    const tokens = q ? q.split(/\s+/).filter(Boolean) : [];
    let visible = 0;
    rows.forEach(r => {
      let match = true;
      if (tokens.length > 0) {
        match = tokens.every(t => r.searchText.includes(t));
      }
      if (match && state.term) match = r.term === state.term;
      if (match && state.role) match = r.role === state.role;
      if (match && state.fav) match = isFavorited(r.tr);
      r.tr.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    return visible;
  }

  function updateStatus(panel, visible, total, state) {
    const el = panel.querySelector('.hutech-courses-filter__status');
    if (!el) return;
    const { t: i18n } = window.HUTECH.i18n;
    const hasFilter = state.q.trim() || state.term || state.role || state.fav;
    if (!hasFilter) {
      el.textContent = i18n('f3.status.total', { total });
      el.classList.remove('hutech-courses-filter__status--empty');
    } else if (visible === 0) {
      const { h, replace } = window.HUTECH.dom;
      const desc = describeFilter(state);
      replace(el,
        i18n('f3.status.empty', { desc }),
        h('a', { href: '#', class: 'hutech-courses-filter__inline-reset' },
          [i18n('f3.status.inlineReset')]),
      );
      el.classList.add('hutech-courses-filter__status--empty');
    } else {
      el.textContent = i18n('f3.status.shown', { visible, total });
      el.classList.remove('hutech-courses-filter__status--empty');
    }
  }

  function describeFilter(state) {
    const { t: i18n } = window.HUTECH.i18n;
    const parts = [];
    if (state.q.trim()) parts.push(i18n('f3.desc.keyword', { q: state.q.trim() }));
    if (state.term) parts.push(i18n('f3.desc.term', { term: state.term }));
    if (state.role) parts.push(i18n('f3.desc.role', { role: state.role }));
    if (state.fav) parts.push(i18n('f3.desc.fav'));
    return i18n('f3.desc.with') + ' ' + parts.join(' + ');
  }

  // --- Wire events ---
  function wirePanel(panel, rows, state, total) {
    const input = panel.querySelector('.hutech-courses-filter__input');
    const clearSearch = panel.querySelector('.hutech-courses-filter__clear-search');
    const selects = panel.querySelectorAll('.hutech-courses-filter__select');
    const favChip = panel.querySelector('.hutech-courses-filter__chip[data-filter="fav"]');
    const reset = panel.querySelector('.hutech-courses-filter__reset');

    function refresh() {
      const visible = applyFilters(rows, state);
      updateStatus(panel, visible, total, state);
      writeState(state);
    }

    let debounceTimer = null;
    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        state.q = input.value;
        refresh();
      }, 200);
    });

    clearSearch.addEventListener('click', () => {
      input.value = '';
      state.q = '';
      refresh();
      input.focus();
    });

    selects.forEach(sel => {
      sel.addEventListener('change', () => {
        state[sel.dataset.filter] = sel.value;
        refresh();
      });
    });

    favChip.addEventListener('click', () => {
      state.fav = !state.fav;
      favChip.classList.toggle('hutech-courses-filter__chip--active', state.fav);
      favChip.setAttribute('aria-pressed', String(state.fav));
      refresh();
    });

    reset.addEventListener('click', () => {
      state.q = '';
      state.term = '';
      state.role = '';
      state.fav = false;
      input.value = '';
      selects.forEach(s => { s.value = ''; });
      favChip.classList.remove('hutech-courses-filter__chip--active');
      favChip.setAttribute('aria-pressed', 'false');
      refresh();
    });

    // Inline reset link in empty state (event delegation since DOM rebuilt)
    panel.querySelector('.hutech-courses-filter__status').addEventListener('click', e => {
      if (e.target.classList.contains('hutech-courses-filter__inline-reset')) {
        e.preventDefault();
        reset.click();
      }
    });

    // Initial render
    refresh();
  }

  // --- Boot ---
  function waitFor(selector, timeout = 15000) {
    return new Promise((resolve, reject) => {
      const found = document.querySelector(selector);
      if (found) return resolve(found);
      const t0 = Date.now();
      const mo = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          mo.disconnect();
          resolve(el);
        } else if (Date.now() - t0 > timeout) {
          mo.disconnect();
          reject(new Error('waitFor timeout: ' + selector));
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    });
  }

  async function boot() {
    try {
      // /courses page có 3 tables: #my_courses_table + #past_enrollments_table + #future_enrollments_table.
      // Đợi 1 trong 3 xuất hiện (Canvas chỉ render table nếu có data).
      const firstTable = await waitFor(
        '#my_courses_table, #past_enrollments_table, #future_enrollments_table',
        20000,
      );
      if (document.getElementById(PANEL_ID)) return;

      // Collect rows từ TẤT CẢ tables để filter áp dụng global (vd. admin filter Vai trò).
      const rows = [
        ...document.querySelectorAll(
          '#my_courses_table tr.course-list-table-row, ' +
          '#past_enrollments_table tr.course-list-table-row, ' +
          '#future_enrollments_table tr.course-list-table-row',
        ),
      ].map(buildRowData);
      const total = rows.length;
      if (total === 0) {
        console.log(TAG, 'no course rows, skip panel');
        return;
      }
      console.log(TAG, 'collected rows across tables:', total);

      // Initial state đọc từ URL params (chỉ active khi user đã apply filter từ trước).
      // Mặc định show ALL — không auto-filter theo term.
      const state = readState();
      // Clear stale URL state nếu term là Default Term (từ session cũ trước khi
      // mình filter default ra khỏi dropdown options).
      if (state.term && isDefaultTerm(state.term)) {
        state.term = '';
      }

      const anchor = firstTable.closest('.table-overflow-container') || firstTable;
      const panel = buildPanel(rows, state);
      anchor.parentNode.insertBefore(panel, anchor);

      wirePanel(panel, rows, state, total);
      console.log(TAG, `panel ready: ${total} rows, state=`, state);
    } catch (e) {
      console.warn(TAG, 'boot failed:', e.message);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

// ─── f4-submissions-dashboard.js ───
// HUTECH Canvas — F4.2 Submissions Dashboard (Custom JS extension)
// File: f4-submissions-dashboard.js
// Refs: Issue #41 [LMS F4.2] — Submission overview dashboard
//
// Approach: Custom JS extension (Option C) instead of LTI 1.3 External Tool.
// - URL `/courses/:id/assignments/:aid` only (assignment view page)
// - Inject "📊 Tổng quan nộp bài" button vào assignment sidebar (#sidebar_content)
// - Click → full-screen modal với stats + table cho assignment ĐÓ (no dropdown)
// - Canvas API via browser session cookie → backend enforces permission
//
// Placement decision 2026-05-27 (Mạnh): Assignment page only (was Course nav).
// Native context UX: user đang xem assignment → click → thấy submissions cùng assignment.
//
// Kill switch: ?disable_hutech_js=1

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) {
    console.log('[HUTECH-F4] disabled via kill switch');
    return;
  }

  const TAG = '[HUTECH-F4]';

  // URL strict match: /courses/<id>/assignments/<aid> (no /new, /syllabus, /edit suffixes OK)
  const URL_MATCH = window.location.pathname.match(/^\/courses\/(\d+)\/assignments\/(\d+)(?:\/edit)?\/?$/);
  if (!URL_MATCH) return;
  const COURSE_ID = URL_MATCH[1];
  const ASSIGNMENT_ID = URL_MATCH[2];

  const { h, t, replace, empty } = window.HUTECH.dom;
  const { t: i18n } = window.HUTECH.i18n;

  // --- Role check via window.ENV (Canvas injects) ---
  function isInstructorOrAdmin() {
    const roles = (window.ENV && window.ENV.current_user_roles) || [];
    return roles.some(r =>
      ['admin', 'root_admin', 'account_admin', 'teacher', 'ta', 'designer'].includes(r),
    );
  }
  if (!isInstructorOrAdmin()) {
    console.log(TAG, 'skip — user is not instructor/admin');
    return;
  }

  // --- Inject "Tổng quan nộp bài" link vào sidebar 'Related Items' list ---
  // Canvas structure: #sidebar_content > ul.page-action-list (<h2>Related Items</h2>)
  //   <li id="assignment-speedgrader-link">SpeedGrader</li>
  //   <li>Download Submissions</li>
  // → Inject thêm <li> ngay sau SpeedGrader để đồng nhất visual + position.
  function injectButton() {
    if (document.getElementById('hutech-f4-trigger-item')) return true;

    const actionList = document.querySelector('#sidebar_content ul.page-action-list');
    if (!actionList) return false;

    const link = h('a', {
      href: '#',
      id: 'hutech-f4-trigger',
      class: 'icon-analytics',
      role: 'button',
      onClick: e => { e.preventDefault(); openDashboard(); },
    }, [i18n('f4.nav.label')]);

    const li = h('li', { id: 'hutech-f4-trigger-item' }, [link]);

    // Insert sau SpeedGrader link nếu có, fallback append cuối list
    const sgLink = actionList.querySelector('#assignment-speedgrader-link');
    if (sgLink && sgLink.nextSibling) {
      actionList.insertBefore(li, sgLink.nextSibling);
    } else if (sgLink) {
      actionList.appendChild(li);
    } else {
      actionList.appendChild(li);
    }
    return true;
  }

  if (!injectButton()) {
    const observer = new MutationObserver(() => {
      if (injectButton()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // --- Canvas API client (browser session cookie) ---
  async function fetchPage(url) {
    const resp = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!resp.ok) throw new Error(`HTTP ${resp.status}: ${resp.statusText}`);
    const link = resp.headers.get('Link') || '';
    const nextEntry = link.split(',').find(s => s.includes('rel="next"'));
    let nextUrl = null;
    if (nextEntry) {
      const m = nextEntry.match(/<([^>]+)>/);
      if (m) nextUrl = m[1];
    }
    return { data: await resp.json(), nextUrl };
  }

  async function fetchAll(url) {
    const results = [];
    let nextUrl = url;
    while (nextUrl) {
      const { data, nextUrl: next } = await fetchPage(nextUrl);
      results.push(...(Array.isArray(data) ? data : [data]));
      nextUrl = next;
    }
    return results;
  }

  // --- sessionStorage cache (TTL 60s) — scoped by user_id ---
  const CURRENT_USER_ID = (window.ENV && window.ENV.current_user_id) || 'anonymous';
  const CACHE_PREFIX = `hutech-f4-u${CURRENT_USER_ID}-c${COURSE_ID}-a${ASSIGNMENT_ID}-`;
  const CACHE_TTL = 60000;

  function cacheGet(key) {
    try {
      const raw = sessionStorage.getItem(CACHE_PREFIX + key);
      if (!raw) return null;
      const { data, ts } = JSON.parse(raw);
      if (Date.now() - ts > CACHE_TTL) return null;
      return data;
    } catch {
      return null;
    }
  }
  function cacheSet(key, data) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify({ data, ts: Date.now() }));
    } catch {
      // sessionStorage may be full/disabled — silent fail
    }
  }
  function cacheClear() {
    Object.keys(sessionStorage)
      .filter(k => k.startsWith(CACHE_PREFIX))
      .forEach(k => sessionStorage.removeItem(k));
  }

  // --- Modal UI ---
  function openDashboard() {
    if (document.getElementById('hutech-f4-modal')) return;

    const onRefresh = () => { cacheClear(); loadAll(); };

    const closeBtn = h('button', {
      class: 'hutech-f4-close', 'aria-label': i18n('f4.modal.close.aria'), onClick: closeDashboard,
    }, ['×']);

    const refreshBtn = h('button', {
      id: 'hutech-f4-refresh', class: 'hutech-f4-btn-secondary',
      title: i18n('f4.refresh.tooltip'), onClick: onRefresh,
    }, [i18n('f4.refresh.label')]);

    const titleNode = h('h2', { id: 'hutech-f4-title' }, [i18n('f4.modal.title')]);
    const assignmentTitle = h('span', {
      id: 'hutech-f4-assignment-title', class: 'hutech-f4-subtitle',
    }, [i18n('f4.assignment.loading')]);

    const tableWrap = h('div', { id: 'hutech-f4-table-wrap', class: 'hutech-f4-table-wrap' });

    const dialog = h('div', {
      class: 'hutech-f4-dialog', role: 'dialog',
      'aria-modal': 'true', 'aria-labelledby': 'hutech-f4-title',
    }, [
      h('div', { class: 'hutech-f4-header' }, [
        h('div', { class: 'hutech-f4-header-title' }, [titleNode, assignmentTitle]),
        h('div', { class: 'hutech-f4-header-actions' }, [refreshBtn, closeBtn]),
      ]),
      h('div', { class: 'hutech-f4-body' }, [
        h('div', { id: 'hutech-f4-stats', class: 'hutech-f4-stats' }),
        tableWrap,
      ]),
    ]);

    const backdrop = h('div', { class: 'hutech-f4-backdrop', onClick: closeDashboard });
    const overlay = h('div', { id: 'hutech-f4-modal' }, [backdrop, dialog]);

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', escHandler);

    loadAll();
  }

  function closeDashboard() {
    const modal = document.getElementById('hutech-f4-modal');
    if (modal) modal.remove();
    document.body.style.overflow = '';
    document.removeEventListener('keydown', escHandler);
  }

  function escHandler(e) {
    if (e.key === 'Escape') closeDashboard();
  }

  // --- Load assignment metadata + submissions song song ---
  async function loadAll() {
    const stats = document.getElementById('hutech-f4-stats');
    const tableWrap = document.getElementById('hutech-f4-table-wrap');
    const titleEl = document.getElementById('hutech-f4-assignment-title');

    replace(stats, h('div', { class: 'hutech-f4-spinner' }, [i18n('f4.assignment.loading')]));
    empty(tableWrap);

    try {
      const [assignment, submissions] = await Promise.all([
        loadAssignment(),
        loadSubmissions(),
      ]);
      currentAssignment = assignment;

      if (titleEl) replace(titleEl, assignment.name + (assignment.due_at
        ? i18n('f4.assignment.due', { date: formatVN(assignment.due_at) })
        : ''));

      renderStats(submissions);
      renderTable(submissions);
    } catch (e) {
      empty(stats);
      replace(
        tableWrap,
        h('div', { class: 'hutech-f4-error' }, [
          i18n('f4.error.loadSubmissions', { message: e.message }),
        ]),
      );
      console.error(TAG, 'loadAll:', e);
    }
  }

  async function loadAssignment() {
    let a = cacheGet('assignment');
    if (!a) {
      const resp = await fetch(
        `/api/v1/courses/${COURSE_ID}/assignments/${ASSIGNMENT_ID}`,
        { credentials: 'same-origin', headers: { Accept: 'application/json' } },
      );
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      a = await resp.json();
      cacheSet('assignment', a);
    }
    return a;
  }

  async function loadSubmissions() {
    let submissions = cacheGet('subs');
    if (!submissions) {
      submissions = await fetchAll(
        `/api/v1/courses/${COURSE_ID}/assignments/${ASSIGNMENT_ID}/submissions` +
          `?include[]=user&include[]=attachments&per_page=100`,
      );
      cacheSet('subs', submissions);
    }
    return submissions;
  }

  function statCard(label, value, kind) {
    return h('div', { class: kind ? `hutech-f4-stat ${kind}` : 'hutech-f4-stat' }, [
      h('div', { class: 'lbl' }, [label]),
      h('div', { class: 'val' }, [String(value)]),
    ]);
  }

  function renderStats(submissions) {
    const total = submissions.length;
    const submitted = submissions.filter(
      s => s.workflow_state === 'submitted' || s.workflow_state === 'graded',
    ).length;
    const unsubmitted = submissions.filter(s => s.workflow_state === 'unsubmitted').length;
    const late = submissions.filter(s => s.late).length;
    const graded = submissions.filter(s => s.workflow_state === 'graded').length;
    const pct = total > 0 ? Math.round((submitted / total) * 100) : 0;

    const progress = h('div', { class: 'hutech-f4-progress' }, [
      h('div', { class: 'bar', style: { width: `${pct}%` } }),
      h('span', {}, [i18n('f4.stats.progress', { pct })]),
    ]);

    replace(
      document.getElementById('hutech-f4-stats'),
      statCard(i18n('f4.stats.total'), total),
      statCard(i18n('f4.stats.submitted'), submitted, 'ok'),
      statCard(i18n('f4.stats.late'), late, 'warn'),
      statCard(i18n('f4.stats.unsubmitted'), unsubmitted, 'err'),
      statCard(i18n('f4.stats.graded'), graded, 'info'),
      progress,
    );
  }

  // --- State cho bulk selection ---
  let currentSubmissions = [];
  let currentAssignment = null;
  const selectedUserIds = new Set();

  function renderTable(submissions) {
    const wrap = document.getElementById('hutech-f4-table-wrap');
    currentSubmissions = submissions;

    if (submissions.length === 0) {
      replace(wrap, h('p', { class: 'hutech-f4-empty' }, [i18n('f4.empty.noStudents')]));
      return;
    }

    const dash = i18n('f4.dash');

    // Header checkbox = select all SV ĐÃ NỘP (có attachments).
    const selectableIds = submissions
      .filter(s => (s.attachments || []).length > 0)
      .map(s => s.user_id);

    const headerCheckbox = h('input', {
      type: 'checkbox',
      id: 'hutech-f4-select-all',
      title: i18n('f4.bulk.selectAll'),
      'aria-label': i18n('f4.bulk.selectAll'),
      onChange: e => {
        const checked = e.target.checked;
        selectedUserIds.clear();
        if (checked) selectableIds.forEach(uid => selectedUserIds.add(uid));
        document.querySelectorAll('.hutech-f4-row-check').forEach(cb => {
          if (selectableIds.includes(parseInt(cb.value, 10))) cb.checked = checked;
        });
        updateBulkBar();
      },
    });

    const thead = h('thead', {}, [
      h('tr', {}, [
        h('th', { class: 'hutech-f4-col-select' }, [headerCheckbox]),
        h('th', {}, [i18n('f4.table.header.no')]),
        h('th', {}, [i18n('f4.table.header.name')]),
        h('th', {}, [i18n('f4.table.header.sis')]),
        h('th', {}, [i18n('f4.table.header.status')]),
        h('th', {}, [i18n('f4.table.header.submittedAt')]),
        h('th', {}, [i18n('f4.table.header.attachments')]),
        h('th', {}, [i18n('f4.table.header.score')]),
        h('th', {}, [i18n('f4.table.header.download')]),
        h('th', {}, ['']),
      ]),
    ]);

    const rows = submissions.map((s, i) => {
      const b = statusBadge(s);
      const user = s.user || {};
      const atts = s.attachments || [];
      const hasFiles = atts.length > 0;

      const attachmentNodes = [];
      if (!hasFiles) {
        attachmentNodes.push(t(dash));
      } else {
        atts.forEach((a, idx) => {
          if (idx > 0) attachmentNodes.push(h('br'));
          attachmentNodes.push(h('a', {
            href: a.url, target: '_blank', rel: 'noopener',
          }, [a.display_name]));
        });
      }

      const score = s.score !== null && s.score !== undefined ? String(s.score) : dash;
      const speedgraderUrl =
        `/courses/${COURSE_ID}/gradebook/speed_grader` +
        `?assignment_id=${ASSIGNMENT_ID}&student_id=${s.user_id}`;

      // Checkbox cho hàng — disabled nếu KHÔNG có file (không có gì để tải)
      const rowCheckbox = h('input', {
        type: 'checkbox',
        class: 'hutech-f4-row-check',
        value: String(s.user_id),
        disabled: hasFiles ? null : true,
        onChange: e => {
          if (e.target.checked) selectedUserIds.add(s.user_id);
          else selectedUserIds.delete(s.user_id);
          updateBulkBar();
        },
      });

      // Download cell — button per student (disabled nếu không file)
      const dlButton = hasFiles
        ? h('button', {
            type: 'button',
            class: 'hutech-f4-dl-single',
            'aria-label': i18n('f4.table.download.singleAria', { name: user.name || '' }),
            title: i18n('f4.table.download.single'),
            onClick: () => downloadStudent(s),
          }, ['↓'])
        : t(dash);

      return h('tr', {}, [
        h('td', { class: 'hutech-f4-col-select' }, [rowCheckbox]),
        h('td', {}, [String(i + 1)]),
        h('td', {}, [user.name || dash]),
        h('td', {}, [user.sis_user_id || dash]),
        h('td', {}, [
          h('span', { class: 'hutech-f4-badge', style: { background: b.color } }, [b.label]),
        ]),
        h('td', {}, [formatVN(s.submitted_at)]),
        h('td', {}, attachmentNodes),
        h('td', {}, [score]),
        h('td', { class: 'hutech-f4-col-dl' }, [dlButton]),
        h('td', {}, [
          h('a', { class: 'hutech-f4-btn', href: speedgraderUrl, target: '_top' },
            [i18n('f4.table.speedgrader')]),
        ]),
      ]);
    });

    const table = h('table', { class: 'hutech-f4-table' }, [thead, h('tbody', {}, rows)]);
    replace(wrap, table);
    updateBulkBar();
  }

  // --- Bulk action bar (hiển thị khi ≥1 SV checked) ---
  function updateBulkBar() {
    const count = selectedUserIds.size;
    let bar = document.getElementById('hutech-f4-bulk-bar');
    if (count === 0) {
      if (bar) bar.remove();
      return;
    }
    if (!bar) {
      bar = h('div', { id: 'hutech-f4-bulk-bar', class: 'hutech-f4-bulk-bar' });
      const wrap = document.getElementById('hutech-f4-table-wrap');
      wrap.parentNode.insertBefore(bar, wrap);
    }
    replace(bar,
      h('span', { class: 'hutech-f4-bulk-count' }, [i18n('f4.bulk.selected', { count })]),
      h('button', {
        type: 'button', class: 'hutech-f4-bulk-btn',
        onClick: downloadSelected,
      }, [i18n('f4.bulk.download', { count })]),
    );
  }

  // --- Download per-student (zip nếu >1 file, direct nếu 1 file) ---
  async function downloadStudent(submission) {
    const atts = submission.attachments || [];
    const user = submission.user || {};
    if (atts.length === 0) return;
    if (atts.length === 1) {
      triggerDownload(atts[0].url, atts[0].display_name);
      return;
    }
    await zipAndDownload([submission], sanitizeFilename(user.name || `user-${submission.user_id}`));
  }

  // --- Download selected (bulk zip) ---
  async function downloadSelected() {
    const selected = currentSubmissions.filter(s => selectedUserIds.has(s.user_id));
    if (selected.length === 0) return;
    const assignmentName = currentAssignment ? currentAssignment.name : `assignment-${ASSIGNMENT_ID}`;
    await zipAndDownload(selected, sanitizeFilename(assignmentName));
  }

  // --- Zip + download core ---
  async function zipAndDownload(submissions, baseName) {
    const bar = document.getElementById('hutech-f4-bulk-bar');
    let progressEl;
    const showProgress = (done, total) => {
      if (bar) {
        progressEl = h('span', { class: 'hutech-f4-bulk-progress' },
          [i18n('f4.bulk.zipping', { done, total })]);
        replace(bar, progressEl);
      }
    };
    try {
      const JSZip = await loadJSZip();
      const zip = new JSZip();
      let totalFiles = 0;
      submissions.forEach(s => { totalFiles += (s.attachments || []).length; });
      let done = 0;
      showProgress(done, totalFiles);

      for (const s of submissions) {
        const user = s.user || {};
        const folderName = sanitizeFilename(user.name || `user-${s.user_id}`)
          + (user.sis_user_id ? `_${sanitizeFilename(user.sis_user_id)}` : '');
        const folder = zip.folder(folderName);
        for (const a of s.attachments || []) {
          try {
            const resp = await fetch(a.url, { credentials: 'same-origin' });
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
            const blob = await resp.blob();
            folder.file(sanitizeFilename(a.display_name), blob);
          } catch (err) {
            console.warn(TAG, `Skip ${user.name}/${a.display_name}:`, err.message);
          }
          done++;
          showProgress(done, totalFiles);
        }
      }
      const blob = await zip.generateAsync({ type: 'blob' });
      const filename = i18n('f4.bulk.zipFilename', { assignment: baseName });
      triggerBlobDownload(blob, filename);
      // Reset bulk bar
      selectedUserIds.clear();
      document.querySelectorAll('.hutech-f4-row-check').forEach(cb => { cb.checked = false; });
      const sa = document.getElementById('hutech-f4-select-all');
      if (sa) sa.checked = false;
      updateBulkBar();
    } catch (e) {
      if (bar) replace(bar,
        h('span', { class: 'hutech-f4-bulk-error' },
          [i18n('f4.bulk.zipError', { message: e.message })]));
      console.error(TAG, 'zipAndDownload:', e);
    }
  }

  // --- JSZip lazy load — SELF-HOSTED (HUTECH nội bộ block external CDN) ---
  // File `infra/customization/vendor/jszip.min.js` COPY vào image qua
  // Dockerfile.hutech-canvas → serve qua /hutech-customization/vendor/.
  // Same-origin → no SRI, no crossOrigin needed.
  let jszipPromise = null;
  function loadJSZip() {
    if (window.JSZip) return Promise.resolve(window.JSZip);
    if (jszipPromise) return jszipPromise;
    jszipPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = '/hutech-customization/vendor/jszip.min.js';
      s.onload = () => {
        if (window.JSZip) resolve(window.JSZip);
        else reject(new Error('JSZip not available after load'));
      };
      s.onerror = () => reject(new Error('JSZip load failed (check /hutech-customization/vendor/jszip.min.js)'));
      document.head.appendChild(s);
    });
    return jszipPromise;
  }

  // --- Download utilities ---
  function triggerDownload(url, filename) {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || '';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function triggerBlobDownload(blob, filename) {
    const url = URL.createObjectURL(blob);
    triggerDownload(url, filename);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  function sanitizeFilename(name) {
    return String(name || '').replace(/[/\\?%*:|"<>]/g, '_').replace(/\s+/g, ' ').trim();
  }

  function statusBadge(s) {
    if (s.workflow_state === 'graded') return { label: i18n('f4.status.graded'), color: '#2D7CE8' };
    if (s.workflow_state === 'submitted') {
      if (s.late) return { label: i18n('f4.status.late'), color: '#F2851A' };
      return { label: i18n('f4.status.submitted'), color: '#198751' };
    }
    if (s.missing) return { label: i18n('f4.status.unsubmitted'), color: '#D63B3B' };
    return { label: i18n('f4.status.unsubmitted'), color: '#888' };
  }

  function formatVN(iso) {
    if (!iso) return i18n('f4.dash');
    try {
      const d = new Date(iso);
      return d.toLocaleString('vi-VN', {
        timeZone: 'Asia/Ho_Chi_Minh',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return iso;
    }
  }

  console.log(TAG, 'loaded for assignment', `${COURSE_ID}/${ASSIGNMENT_ID}`);
})();

// ─── google-slide-wrapper.js ───
// HUTECH Canvas — "Lớp vỏ" inline bọc & ĐÈ HOÀN TOÀN khung Google Slides
// ---------------------------------------------------------------------------
// Bài giảng nhúng Google Slides (có GIF/YouTube → phải dùng iframe Google). iframe
// là cross-origin nên KHÔNG sửa được chrome Google từ bên trong → ta ĐÈ bên ngoài:
//   • Khung đúng TỈ LỆ slide (lấy từ width/height iframe) → slide lấp đầy, KHÔNG
//     còn dải xám trên/dưới (dải xám sinh ra khi khung cao/thấp hơn tỉ lệ slide).
//   • Header HUTECH phủ mép trên; dải HUTECH phủ ĐÈ thanh công cụ Google ở đáy
//     (nút ◀▶, bộ đếm, menu ⋮, Open-in-new-window) → không còn dấu vết Google.
//
// Bảng màu: header phẳng #f2f4f4 viền #e8eaec · tên bài #F37021 · badge #ED1B24 · chữ #333.
//
// Tuỳ biến (không bắt buộc):
//   window.HUTECH_SLIDE = { badge:'HỌC LIỆU CHÍNH THỨC', zoom:1.08, ratio:56.25 }
//     - badge:''  → ẩn badge đỏ
//     - zoom: mức phóng to đẩy viền+thanh Google ra ngoài (tăng 1.12–1.18 nếu vẫn ló)
//     - ratio: tỉ lệ khung % (56.25 = 16:9; dùng 75 nếu slide 4:3)
//   Trên iframe: data-hutech-title="Tên bài", data-hutech-note="Ghi chú đỏ", data-hutech-ratio="75"
//
// Kill switch chung: ?disable_hutech_js=1
(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || /disable_hutech_js/.test(window.location.search)) return;

  const TAG = '[HUTECH-SLIDE]';
  const CFG = window.HUTECH_SLIDE || {};
  const DEFAULT_BADGE = CFG.badge != null ? CFG.badge : '';
  const DEFAULT_TITLE = CFG.defaultTitle || 'Bài giảng điện tử';
  const COVER = CFG.cover != null ? CFG.cover : 46; // px dải phủ thanh công cụ Google
  const WRAP_CLASS = 'hutech-slide-wrap';
  const SEL = 'iframe[src*="docs.google.com/presentation"]';

  // PRE-HIDE đặt trong custom-css/google-slide-prehide.css (nạp sớm trong <head> qua
  // css_overrides) — TRƯỚC khi bundle JS chạy → không lóe Google thô. JS chỉ gắn
  // .hutech-shown/.hutech-done để hiện khi đã bọc + load xong.

  function isGoogleSlides(src) {
    return /docs\.google\.com\/presentation\//i.test(src || '');
  }
  function cleanTitle(s) {
    return (s || '').replace(/\s+/g, ' ').trim().slice(0, 140);
  }

  function injectStyle() {
    if (document.getElementById('hutech-slide-style')) return;
    const st = document.createElement('style');
    st.id = 'hutech-slide-style';
    st.textContent = [
      '.hutech-slide-wrap{margin:0 0 12px;border:1px solid #e3e8ef;border-radius:0;overflow:hidden;',
      'background:#F8F9FA;color:#333;',
      "font-family:'Montserrat','Inter',system-ui,-apple-system,Segoe UI,sans-serif;}",
      // Header (phủ mép trên)
      '.hutech-slide-head{display:flex;align-items:center;gap:10px;background-color:#f2f4f4;color:var(--hutech-primary);',
      'border:1px solid #e8eaec;padding:10px 14px;min-height:48px;box-sizing:border-box;}',
      '.hutech-slide-head .hs-icon{display:inline-flex;width:26px;height:26px;flex:0 0 26px;align-items:center;',
      'justify-content:center;border-radius:0;background:#e8eaec;color:var(--hutech-primary);font-size:15px;line-height:1;}',
      '.hutech-slide-head .hs-label{font-size:12px;font-weight:600;color:var(--hutech-primary);white-space:nowrap;letter-spacing:.2px;}',
      '.hutech-slide-head .hs-title{flex:1 1 auto;min-width:0;font-size:15px;font-weight:800;color:var(--hutech-primary);',
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.hutech-slide-head .hs-badge{flex:0 0 auto;background:#ED1B24;color:#fff;font-size:11px;font-weight:700;',
      'letter-spacing:.4px;text-transform:uppercase;padding:4px 10px;border-radius:0;white-space:nowrap;}',
      '.hutech-slide-head .hs-fs{flex:0 0 auto;background:#fff;color:var(--hutech-primary);border:1px solid #e8eaec;border-radius:3px;',
      'cursor:pointer;font-size:15px;line-height:1;padding:6px 10px;transition:background .15s;}',
      '.hutech-slide-head .hs-fs:hover{background:#e8eaec;}',
      // Khung 16:9, nền tối. iframe PHÓNG TO nhẹ từ mép trên (scale) + overflow:hidden
      // → đẩy viền xám + thanh công cụ Google (dưới/cạnh) ra ngoài vùng nhìn, giữ
      // tiêu đề slide ở trên. Không phụ thuộc Google render kiểu gì.
      '.hutech-slide-body{position:relative;width:100%;height:0;background:#f8fafc;overflow:hidden;}',
      '.hutech-slide-body>iframe{position:absolute!important;top:-1px!important;left:50%!important;',
      'width:100%!important;height:100%!important;border:0!important;margin:0!important;display:block;',
      'transform:translateX(-50%) scale(var(--hs-zoom,1.055))!important;transform-origin:center top!important;}',
      // Spinner "đang tải" hiện trong khi iframe chưa load (tránh khung trống)
      '.hutech-slide-body::before{content:"";position:absolute;top:50%;left:50%;width:34px;height:34px;',
      'margin:-17px 0 0 -17px;border:3px solid rgba(15,23,42,.12);border-top-color:#F37021;',
      'border-radius:50%;animation:hutechSlideSpin .8s linear infinite;z-index:1;}',
      '.hutech-slide-wrap.hutech-done .hutech-slide-body::before{display:none;}',
      '@keyframes hutechSlideSpin{to{transform:rotate(360deg)}}',
      // Fullscreen
      '.hutech-slide-wrap:fullscreen{margin:0;border-radius:0;height:100vh;display:flex;flex-direction:column;background:#f8fafc;}',
      '.hutech-slide-wrap:fullscreen .hutech-slide-body{flex:1 1 auto;height:auto;padding:0!important;}',
    ].join('');
    document.head.appendChild(st);
  }

  function findTitle(iframe) {
    const dt = iframe.getAttribute('data-hutech-title');
    if (dt) return cleanTitle(dt);
    const t = iframe.getAttribute('title');
    if (t && !/google|presentation|slides|embed/i.test(t)) return cleanTitle(t);
    let el = iframe.closest('p,div,figure') || iframe;
    for (let i = 0; i < 6 && el; i++) {
      let sib = el.previousElementSibling;
      while (sib) {
        if (/^H[1-6]$/.test(sib.tagName) && sib.textContent.trim()) return cleanTitle(sib.textContent);
        const h = sib.querySelector && sib.querySelector('h1,h2,h3,h4');
        if (h && h.textContent.trim()) return cleanTitle(h.textContent);
        sib = sib.previousElementSibling;
      }
      el = el.parentElement;
    }
    const ph = document.querySelector('.page-title,h1.ic-Action-header__Heading,.show-content h1,h1');
    if (ph && ph.textContent.trim()) return cleanTitle(ph.textContent);
    return DEFAULT_TITLE;
  }

  // Tỉ lệ khung = tỉ lệ slide (lấy từ width/height iframe) → slide lấp đầy, không dải xám.
  function aspectPct(iframe) {
    const w = parseFloat(iframe.getAttribute('width')) || iframe.clientWidth || 0;
    const h = parseFloat(iframe.getAttribute('height')) || iframe.clientHeight || 0;
    if (w > 0 && h > 0) {
      const pct = (h / w) * 100;
      if (pct > 30 && pct < 120) return Math.round(pct * 100) / 100;
    }
    return 56.25; // 16:9 mặc định
  }

  // Vô hiệu hoá "khung" của các phần tử BAO NGOÀI ôm sát lớp vỏ (container embed
  // của Canvas/Google còn sót): xoá viền/nền/bóng/padding + bỏ giới hạn rộng để
  // lớp vỏ HUTECH chiếm trọn chỗ, không bị khung ngoài bọc/ép nhỏ.
  function neutralizeFrame(wrap) {
    let p = wrap.parentElement, hops = 0;
    while (p && hops < 5) {
      const cls = (p.className && p.className.toString ? p.className.toString() : '') || '';
      if (p.tagName === 'BODY' || p.id === 'content' ||
          /user_content\b|show-content|ic-Layout|user-content|description|content-wrapper/i.test(cls)) break;
      // chỉ đụng container ôm SÁT (chỉ chứa duy nhất chuỗi của ta) → an toàn layout
      if (p.children.length !== 1) break;
      p.style.setProperty('border', '0', 'important');
      p.style.setProperty('background', 'transparent', 'important');
      p.style.setProperty('box-shadow', 'none', 'important');
      p.style.setProperty('padding', '0', 'important');
      p.style.setProperty('min-height', '0', 'important');
      p.style.setProperty('max-width', 'none', 'important');
      p.style.setProperty('width', 'auto', 'important');
      p.style.setProperty('height', 'auto', 'important');
      p = p.parentElement;
      hops++;
    }
  }

  // Ép style iframe (thắng mọi CSS/script Canvas: #file_content height:400px, float).
  function forceIframeStyle(iframe, zoom) {
    const S = iframe.style;
    S.setProperty('position', 'absolute', 'important');
    S.setProperty('top', '-1px', 'important');
    S.setProperty('left', '50%', 'important');
    S.setProperty('width', '100%', 'important');
    S.setProperty('height', '100%', 'important');
    S.setProperty('float', 'none', 'important');
    S.setProperty('margin', '0', 'important');
    S.setProperty('max-width', 'none', 'important');
    S.setProperty('transform', 'translateX(-50%) scale(' + zoom + ')', 'important');
    S.setProperty('transform-origin', 'center top', 'important');
  }

  function wrapOne(iframe) {
    if (!iframe || iframe.dataset.hutechSlide === '1') return;
    if (iframe.closest('.' + WRAP_CLASS)) { iframe.dataset.hutechSlide = '1'; return; }
    if (!isGoogleSlides(iframe.getAttribute('src') || '')) return;
    iframe.dataset.hutechSlide = '1';

    const title = findTitle(iframe);
    const note = iframe.getAttribute('data-hutech-note');
    const badge = note != null ? (note || 'Quan trọng') : DEFAULT_BADGE;

    const wrap = document.createElement('div');
    wrap.className = WRAP_CLASS;

    const head = document.createElement('div');
    head.className = 'hutech-slide-head';
    head.innerHTML =
      '<span class="hs-icon" aria-hidden="true">▣</span>' +
      '<span class="hs-label">Bài giảng:</span>' +
      '<span class="hs-title"></span>' +
      (badge ? '<span class="hs-badge"></span>' : '') +
      '<button type="button" class="hs-fs" title="Toàn màn hình" aria-label="Toàn màn hình">⛶</button>';
    head.querySelector('.hs-title').textContent = title;
    if (badge) head.querySelector('.hs-badge').textContent = badge;

    const body = document.createElement('div');
    body.className = 'hutech-slide-body';
    // Ép 16:9 (đa số Google Slides) → hết letterbox. Override: data-hutech-ratio.
    const ratio = parseFloat(iframe.getAttribute('data-hutech-ratio')) || CFG.ratio || 56.25;
    body.style.paddingBottom = ratio + '%';
    // Mức phóng to đẩy viền+thanh Google ra ngoài (tăng nếu vẫn ló, vd 1.12–1.18).
    const zoom = CFG.zoom != null ? CFG.zoom : 1.055;
    body.style.setProperty('--hs-zoom', String(zoom));

    // Canvas bọc embed external trong widget <ul class="ui-listview"> gồm li1 (link
    // "dư") + li2 (iframe) + viền. THAY luôn cả widget bằng khung HUTECH → bỏ link
    // li1, viền, mọi thứ Canvas/Google. Nếu không có widget thì thay tại chỗ iframe.
    const mount = iframe.closest('ul.ui-listview, .ui-listview') || iframe;
    mount.parentNode.insertBefore(wrap, mount);
    wrap.appendChild(head);
    wrap.appendChild(body);
    body.appendChild(iframe);   // chuyển iframe vào khung TRƯỚC khi xoá widget
    if (mount !== iframe) { try { mount.remove(); } catch (e) {} }

    iframe.removeAttribute('width');
    iframe.removeAttribute('height');
    iframe.removeAttribute('id');   // gỡ #file_content → Canvas thôi đặt lại height:400px
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'fullscreen; autoplay; encrypted-media');
    forceIframeStyle(iframe, zoom);

    // Canvas có thể đặt lại height/style sau khi tải → giám sát & ép lại (tự dừng vì
    // đã gỡ id; chỉ ép khi lệch để tránh vòng lặp).
    if (!iframe.dataset.hutechStyleObs) {
      iframe.dataset.hutechStyleObs = '1';
      const so = new MutationObserver(() => {
        if (iframe.style.height !== '100%' || iframe.style.position !== 'absolute') {
          forceIframeStyle(iframe, zoom);
        }
      });
      so.observe(iframe, { attributes: true, attributeFilter: ['style', 'height', 'width'] });
    }

    head.querySelector('.hs-fs').addEventListener('click', () => {
      if (document.fullscreenElement) { try { document.exitFullscreen(); } catch (e) {} return; }
      const req = wrap.requestFullscreen || wrap.webkitRequestFullscreen;
      if (req) { try { req.call(wrap); } catch (e) {} }
    });

    neutralizeFrame(wrap);  // xoá khung của container bao ngoài (Canvas/Google)

    // Hiện iframe + ẩn spinner KHI iframe load xong trong khung (sau cú reload do
    // reparent) → mượt, người dùng không thấy giao diện Google thô / "cú nhấp".
    const reveal = () => { iframe.classList.add('hutech-shown'); wrap.classList.add('hutech-done'); };
    iframe.addEventListener('load', reveal, { once: true });
    setTimeout(reveal, 1800);  // fallback nếu load đã fire trước khi gắn listener

    console.log(TAG, 'đã bọc Google Slides:', title);
  }

  function run() {
    injectStyle();
    document.querySelectorAll(SEL).forEach(wrapOne);
  }

  // Bọc SỚM nhất có thể (bỏ delay 400ms) để rút ngắn thời gian khung trống/spinner.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  }
  run();                       // thử ngay (iframe server-render có thể đã có)
  setTimeout(run, 300);        // retry bắt iframe nạp hơi trễ

  function attachObserver() {
    if (window._hutechSlideObs || !document.body) return;
    const mo = new MutationObserver(muts => {
      for (const m of muts) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches(SEL)) || (n.querySelector && n.querySelector(SEL))) {
            clearTimeout(window._hutechSlideDeb);
            window._hutechSlideDeb = setTimeout(run, 250);
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    window._hutechSlideObs = mo;
  }
  if (document.body) attachObserver();
  else document.addEventListener('DOMContentLoaded', attachObserver);

  console.log(TAG, 'Google Slides inline wrapper loaded');
})();

// ─── gradebook-csv-bom.js ───
// HUTECH Canvas — Gradebook CSV UTF-8 BOM injection
// File: gradebook-csv-bom.js
// Ref: QA staging 2026-05-29 item 7.2 — Excel hiển thị sai tiếng Việt có dấu
//      khi mở CSV export từ Gradebook vì Canvas KHÔNG prepend UTF-8 BOM.
//
// Strategy:
//   Canvas Gradebook flow: poll /api/v1/progress/<id> → when complete, response
//   has results.attachment.url → Canvas gọi assignLocation(attachment.url) →
//   browser GET file → download.
//
//   Browser khóa Location.prototype.assign + window.location.assign (security)
//   nên không monkey-patch trực tiếp được. Thay vào đó:
//
//   1. Monkey-patch window.fetch + XMLHttpRequest
//   2. Khi response polling URL match `/api/v1/progress/`, JSON parse
//   3. Nếu results.attachment.url xuất hiện (= export hoàn tất):
//      a. Background fetch URL → prepend BOM → trigger Blob download (save dialog)
//      b. REPLACE results.attachment.url → '#hutech-handled-{ts}' (location.hash, no-op)
//   4. Canvas's assignLocation('#hutech-handled-...') chỉ set hash, không navigate.
//
//   Đồng thời giữ click interceptor cho <a href="…/files/X/download"> case của
//   "Previous Export" link.
//
// Kill switch: ?disable_hutech_js=1

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) {
    console.log('[HUTECH-CSV] disabled via kill switch');
    return;
  }

  const TAG = '[HUTECH-CSV]';
  const BOM = '﻿';
  const HANDLED_PREFIX = '#hutech-csv-handled-';
  // Canvas Gradebook export flow:
  //   1. POST /api/v1/courses/<id>/gradebook_csv  → returns progress_id + attachment_id
  //   2. GET  /api/v1/progress/<id>               → poll workflow_state (KHÔNG có file URL ở response)
  //   3. GET  /api/v1/users/<userId>/files/<attachmentId>  ← URL file ở response.url
  //   4. assignLocation(response.url)             → browser download
  // → Mình intercept response của bước 3 (file metadata endpoint).
  const FILE_META_RE = /\/api\/v1\/users\/\d+\/files\/\d+(?:$|\?)/;
  const PROGRESS_PATH_RE = /\/api\/v1\/progress\/\d+/;
  const FILES_DOWNLOAD_RE = /\/files\/\d+\/download/;

  function isCsvDownloadUrl(url) {
    if (!url) return false;
    try {
      const u = new URL(url, window.location.origin);
      const path = u.pathname.toLowerCase();
      const qs = u.search.toLowerCase();
      return (
        /\.csv($|\?)/i.test(path) ||
        path.includes('gradebook.csv') ||
        path.includes('gradebook_csv') ||
        (FILES_DOWNLOAD_RE.test(path) && qs.includes('download_frd'))
      );
    } catch (_e) {
      return false;
    }
  }

  // Fetch URL, prepend BOM, trigger Blob download. CHỈ download nếu content
  // detected là CSV. Trả về Promise resolve khi user save dialog appear.
  async function downloadWithBom(url, filenameHint) {
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) throw new Error(`HTTP ${res.status} fetch ${url}`);

    const cd = res.headers.get('content-disposition') || '';
    const ct = res.headers.get('content-type') || '';
    const filenameMatch = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i);
    const filename = decodeURIComponent(
      (filenameMatch && filenameMatch[1]) || filenameHint || 'export.csv',
    );

    if (!ct.includes('csv') && !filename.toLowerCase().endsWith('.csv')) {
      throw new Error('not-csv');
    }

    const text = await res.text();
    const bomText = text.startsWith(BOM) ? text : BOM + text;
    const blob = new Blob([bomText], { type: 'text/csv;charset=utf-8' });

    const blobUrl = URL.createObjectURL(blob);
    const dl = document.createElement('a');
    dl.href = blobUrl;
    dl.download = filename;
    dl.style.display = 'none';
    document.body.appendChild(dl);
    dl.click();
    setTimeout(() => {
      document.body.removeChild(dl);
      URL.revokeObjectURL(blobUrl);
    }, 1500);

    console.log(TAG, 'CSV downloaded with BOM:', filename, `(${bomText.length} bytes)`);
  }

  // Helper — handle file metadata response (axios GET /api/v1/users/X/files/Y)
  // Response shape: { url: "https://.../files/X/download?download_frd=1&verifier=...", display_name: "...", ... }
  function maybeSwapFileMetaResponse(data, source) {
    if (!data || typeof data !== 'object') return null;
    const fileUrl = data.url;
    if (!fileUrl || !isCsvDownloadUrl(fileUrl)) return null;

    console.log(TAG, `intercept ${source} file meta, real URL:`, fileUrl);
    downloadWithBom(fileUrl, data.display_name || data.filename || null).catch(e => {
      if (e.message !== 'not-csv') console.warn(TAG, 'BOM download fail:', e.message);
    });

    // Replace URL → hash anchor; assignLocation('#hutech-...') chỉ set hash, không navigate
    return { ...data, url: HANDLED_PREFIX + Date.now() };
  }

  // Opt-out marker: nếu request có header `X-HUTECH-Skip-CSV-Bom: 1`, interceptor
  // bypass. Dùng cho XLSX export gọi cùng endpoint nhưng muốn raw response.
  function hasSkipHeader(init) {
    if (!init || !init.headers) return false;
    const h = init.headers;
    if (typeof h.get === 'function') return h.get('X-HUTECH-Skip-CSV-Bom') === '1';
    return h['X-HUTECH-Skip-CSV-Bom'] === '1' || h['x-hutech-skip-csv-bom'] === '1';
  }

  // ── Interceptor 1: monkey-patch fetch ────────────────────────────────────
  const origFetch = window.fetch.bind(window);
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : input && input.url;
    const res = await origFetch(input, init);

    if (hasSkipHeader(init)) return res;

    if (url && FILE_META_RE.test(url) && res.ok && res.status === 200) {
      try {
        const cloned = res.clone();
        const data = await cloned.json();
        const swapped = maybeSwapFileMetaResponse(data, 'fetch');
        if (swapped) {
          return new Response(JSON.stringify(swapped), {
            status: res.status,
            statusText: res.statusText,
            headers: res.headers,
          });
        }
      } catch (e) {
        console.warn(TAG, 'fetch file meta parse fail:', e.message);
      }
    }

    return res;
  };

  // ── Interceptor 2: monkey-patch XMLHttpRequest ───────────────────────────
  const OrigXHR = window.XMLHttpRequest;
  const XHR_URL = Symbol('hutech-xhr-url');
  const XHR_SKIP = Symbol('hutech-xhr-skip');

  function patchXHRPrototype() {
    const origOpen = OrigXHR.prototype.open;
    const origSend = OrigXHR.prototype.send;

    OrigXHR.prototype.open = function (method, url) {
      this[XHR_URL] = url;
      this[XHR_SKIP] = false;
      return origOpen.apply(this, arguments);
    };

    const origSetHeader = OrigXHR.prototype.setRequestHeader;
    OrigXHR.prototype.setRequestHeader = function (name, value) {
      if (String(name).toLowerCase() === 'x-hutech-skip-csv-bom' && value === '1') {
        this[XHR_SKIP] = true;
      }
      return origSetHeader.apply(this, arguments);
    };

    OrigXHR.prototype.send = function () {
      const xhr = this;
      const url = xhr[XHR_URL];
      if (!xhr[XHR_SKIP] && url && FILE_META_RE.test(url)) {
        const handleComplete = () => {
          if (xhr.readyState !== 4 || xhr.status !== 200) return;
          try {
            const raw = xhr.responseText;
            if (!raw) return;
            const data = JSON.parse(raw);
            const swapped = maybeSwapFileMetaResponse(data, 'XHR');
            if (swapped) {
              const swappedJson = JSON.stringify(swapped);
              Object.defineProperty(xhr, 'responseText', {
                configurable: true,
                get: () => swappedJson,
              });
              // axios reads xhr.response when responseType is 'json' or '';
              // override returns string (axios.transformResponse JSON.parse OK).
              Object.defineProperty(xhr, 'response', {
                configurable: true,
                get: () => swappedJson,
              });
            }
          } catch (e) {
            console.warn(TAG, 'XHR file meta parse fail:', e.message);
          }
        };
        xhr.addEventListener('readystatechange', handleComplete);
      }
      return origSend.apply(this, arguments);
    };
  }

  try {
    patchXHRPrototype();
    console.log(TAG, 'XMLHttpRequest patched');
  } catch (e) {
    console.warn(TAG, 'XHR patch fail:', e.message);
  }

  // ── Interceptor 3: click vào <a> CSV (Previous Export link, generic) ────
  document.addEventListener(
    'click',
    function (e) {
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (!isCsvDownloadUrl(a.href)) return;
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0) return;

      e.preventDefault();
      e.stopPropagation();
      console.log(TAG, 'intercept <a> click:', a.href);

      downloadWithBom(a.href, a.getAttribute('download') || null).catch(err => {
        if (err.message !== 'not-csv') console.warn(TAG, 'click BOM fail, fallback:', err.message);
        window.location.href = a.href;
      });
    },
    true,
  );

  console.log(TAG, 'Gradebook CSV BOM interceptor loaded (fetch + XHR + click)');
})();

// ─── gradebook-xlsx-export.js ───
// HUTECH Canvas — Gradebook XLSX export (Phase 7.2 enhancement)
// File: gradebook-xlsx-export.js
// Ref: QA staging 2026-05-29 item 7.2 — bổ sung Excel native XLSX export, song song với
//      CSV (đã có BOM interceptor `gradebook-csv-bom.js`). XLSX binary nên Excel mở
//      luôn đúng UTF-8, không lo BOM detection.
//
// Strategy:
//   1. MutationObserver watch Gradebook Action menu (data-menu-id="export-all")
//   2. Khi menu render, inject menu item mới "Xuất toàn bộ số điểm ra Excel" với icon SVG
//   3. Click → reuse Canvas GradebookExportManager flow (POST gradebook_csv) qua axios
//      lazy import KHÔNG khả thi → workaround: trigger Canvas Export Current click,
//      intercept `attachment.url` ở file meta endpoint (cùng pattern BOM interceptor),
//      fetch CSV, parse, write XLSX via JSZip, Blob download.
//
//   Approach UI: thay vì hijack Canvas flow, thực ra simpler = fetch directly từ
//   Canvas CSV endpoint URL có sẵn trong ENV.GRADEBOOK_OPTIONS, sau đó convert.
//
// Kill switch: ?disable_hutech_js=1

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) {
    return;
  }

  const TAG = '[HUTECH-XLSX]';

  // ── Lazy load JSZip (self-hosted, share với F4 dashboard) ────────────────
  let jszipPromise = null;
  function loadJSZip() {
    if (window.JSZip) return Promise.resolve(window.JSZip);
    if (jszipPromise) return jszipPromise;
    jszipPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = '/hutech-customization/vendor/jszip.min.js';
      s.onload = () => (window.JSZip ? resolve(window.JSZip) : reject(new Error('JSZip not loaded')));
      s.onerror = () => reject(new Error('JSZip script error'));
      document.head.appendChild(s);
    });
    return jszipPromise;
  }

  // ── CSV parser — handle quoted strings, escaped quotes, embedded CRLF ───
  function parseCSV(text) {
    const rows = [];
    let row = [];
    let cell = '';
    let inQuotes = false;
    let i = 0;
    while (i < text.length) {
      const c = text[i];
      if (inQuotes) {
        if (c === '"') {
          if (text[i + 1] === '"') {
            cell += '"';
            i += 2;
            continue;
          }
          inQuotes = false;
          i++;
          continue;
        }
        cell += c;
        i++;
      } else {
        if (c === '"') {
          inQuotes = true;
          i++;
        } else if (c === ',') {
          row.push(cell);
          cell = '';
          i++;
        } else if (c === '\r' && text[i + 1] === '\n') {
          row.push(cell);
          rows.push(row);
          row = [];
          cell = '';
          i += 2;
        } else if (c === '\n' || c === '\r') {
          row.push(cell);
          rows.push(row);
          row = [];
          cell = '';
          i++;
        } else {
          cell += c;
          i++;
        }
      }
    }
    if (cell.length > 0 || row.length > 0) {
      row.push(cell);
      rows.push(row);
    }
    // Skip BOM nếu có ở cell đầu tiên
    if (rows.length > 0 && rows[0].length > 0 && rows[0][0].charCodeAt(0) === 0xfeff) {
      rows[0][0] = rows[0][0].slice(1);
    }
    return rows;
  }

  // ── XLSX writer — minimal subset (1 sheet, inline strings, no styles) ───
  function xmlEscape(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  }

  function colLetter(n) {
    // 0-indexed: 0=A, 25=Z, 26=AA, ...
    let r = '';
    n++;
    while (n > 0) {
      const rem = (n - 1) % 26;
      r = String.fromCharCode(65 + rem) + r;
      n = Math.floor((n - 1) / 26);
    }
    return r;
  }

  function isNumeric(v) {
    if (typeof v !== 'string') return false;
    if (v === '' || /\s/.test(v)) return false;
    return /^-?\d+(\.\d+)?$/.test(v);
  }

  function buildSheetXml(rows) {
    const sheetRows = rows
      .map((row, rIdx) => {
        const cells = row
          .map((val, cIdx) => {
            const ref = colLetter(cIdx) + (rIdx + 1);
            if (val == null || val === '') return '';
            if (isNumeric(val)) {
              return `<c r="${ref}"><v>${val}</v></c>`;
            }
            return `<c r="${ref}" t="inlineStr"><is><t xml:space="preserve">${xmlEscape(val)}</t></is></c>`;
          })
          .filter(Boolean)
          .join('');
        return `<row r="${rIdx + 1}">${cells}</row>`;
      })
      .join('');
    return (
      '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n' +
      '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
      `<sheetData>${sheetRows}</sheetData>` +
      '</worksheet>'
    );
  }

  const WORKBOOK_XML =
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n' +
    '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" ' +
    'xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">' +
    '<sheets><sheet name="Bảng điểm" sheetId="1" r:id="rId1"/></sheets>' +
    '</workbook>';

  const WORKBOOK_RELS_XML =
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n' +
    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
    '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>' +
    '</Relationships>';

  const ROOT_RELS_XML =
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n' +
    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
    '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>' +
    '</Relationships>';

  const CONTENT_TYPES_XML =
    '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n' +
    '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">' +
    '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>' +
    '<Default Extension="xml" ContentType="application/xml"/>' +
    '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>' +
    '<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>' +
    '</Types>';

  async function csvToXlsxBlob(csvText) {
    const JSZip = await loadJSZip();
    const rows = parseCSV(csvText);
    const zip = new JSZip();
    zip.file('[Content_Types].xml', CONTENT_TYPES_XML);
    zip.folder('_rels').file('.rels', ROOT_RELS_XML);
    zip.folder('xl').file('workbook.xml', WORKBOOK_XML);
    zip.folder('xl/_rels').file('workbook.xml.rels', WORKBOOK_RELS_XML);
    zip.folder('xl/worksheets').file('sheet1.xml', buildSheetXml(rows));
    return zip.generateAsync({
      type: 'blob',
      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      compression: 'DEFLATE',
    });
  }

  // ── Fetch CSV qua Canvas API (reuse Canvas flow) ────────────────────────
  // Canvas Gradebook export: POST /api/v1/courses/<id>/gradebook_csv với params
  // Trả về { progress_id, attachment_id, filename }
  // → poll /api/v1/progress/<id> đến completed
  // → GET /api/v1/users/<userId>/files/<attachmentId> → response.url
  // → fetch URL = CSV file thực
  async function pollProgress(progressId, timeout = 5 * 60 * 1000) {
    const startedAt = Date.now();
    while (Date.now() - startedAt < timeout) {
      const r = await fetch(`/api/v1/progress/${progressId}`, { credentials: 'include', headers: { 'X-HUTECH-Skip-CSV-Bom': '1' } });
      if (!r.ok) throw new Error(`Progress poll HTTP ${r.status}`);
      const j = await r.json();
      if (j.workflow_state === 'completed') return j;
      if (j.workflow_state === 'failed') throw new Error('Export failed: ' + (j.message || 'unknown'));
      await new Promise(res => setTimeout(res, 2000));
    }
    throw new Error('Export timeout');
  }

  function getCsrfToken() {
    const m = document.cookie.match(/_csrf_token=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  async function startExportAndDownload(currentView) {
    const env = window.ENV || {};
    const opts = env.GRADEBOOK_OPTIONS || {};
    const exportUrl = opts.export_gradebook_csv_url;
    const userId = (env.current_user_id || '').toString();
    if (!exportUrl || !userId) {
      throw new Error('Canvas ENV.GRADEBOOK_OPTIONS thiếu — KHÔNG phải Gradebook page?');
    }

    // POST trigger export
    const params = new URLSearchParams();
    if (currentView) params.set('grading_period_id', opts.grading_period_id || '');
    const postRes = await fetch(exportUrl, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-CSRF-Token': getCsrfToken(),
        Accept: 'application/json',
        'X-HUTECH-Skip-CSV-Bom': '1',
      },
      body: params.toString(),
    });
    if (!postRes.ok) throw new Error(`Start export HTTP ${postRes.status}`);
    const job = await postRes.json();
    const { progress_id: progressId, attachment_id: attachmentId, filename } = job;

    // Poll progress
    await pollProgress(progressId);

    // Get attachment metadata
    const metaRes = await fetch(`/api/v1/users/${userId}/files/${attachmentId}`, {
      credentials: 'include',
    });
    if (!metaRes.ok) throw new Error(`File meta HTTP ${metaRes.status}`);
    const meta = await metaRes.json();

    // Download CSV
    const csvRes = await fetch(meta.url, { credentials: 'include', headers: { 'X-HUTECH-Skip-CSV-Bom': '1' } });
    if (!csvRes.ok) throw new Error(`Download CSV HTTP ${csvRes.status}`);
    const csvText = await csvRes.text();

    // Convert to XLSX
    const xlsxBlob = await csvToXlsxBlob(csvText);
    const xlsxFilename = (filename || meta.display_name || 'gradebook')
      .replace(/\.csv$/i, '')
      .concat('.xlsx');

    const url = URL.createObjectURL(xlsxBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = xlsxFilename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 1500);

    console.log(TAG, 'XLSX downloaded:', xlsxFilename, `(${(xlsxBlob.size / 1024).toFixed(1)} KB)`);
  }

  // ── UI injection: append menu item vào Action → Export dropdown ─────────
  // Canvas dropdown render bằng InstUI Menu. Menu items có data-menu-id.
  // Hook: khi `<span data-menu-id="export-all">` xuất hiện, tìm parent <li>
  // (MenuItem) clone structure, gắn label "Xuất toàn bộ số điểm ra Excel" + onclick.

  const ICON_SVG =
    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align: -3px; margin-right: 6px;" aria-hidden="true">' +
    '<path d="M21 3H3C2.4 3 2 3.4 2 4V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20V4C22 3.4 21.6 3 21 3Z" fill="#1F7246"/>' +
    '<path d="M14.6 7H17.4L13.5 12L17.5 17H14.7L12 13.5L9.3 17H6.5L10.5 12L6.6 7H9.4L12 10.5L14.6 7Z" fill="white"/>' +
    '</svg>';

  let injected = false;

  // XSS-safe: build label content (icon SVG + text) without innerHTML.
  // SVG là constant string từ source này, KHÔNG dùng user input → safe.
  // Dùng DOMParser parse SVG → append element + appendChild text node.
  function buildLabelContent(el, svgString, text) {
    while (el.firstChild) el.removeChild(el.firstChild);
    try {
      const svgDoc = new DOMParser().parseFromString(svgString, 'image/svg+xml');
      const svg = svgDoc.documentElement;
      if (svg && svg.tagName.toLowerCase() === 'svg') {
        el.appendChild(svg);
      }
    } catch (_e) { /* parse fail: fallback chỉ text */ }
    el.appendChild(document.createTextNode(text));
  }

  // Save children references để restore sau khi swap label tạm thời.
  function snapshotChildren(el) {
    return Array.from(el.childNodes).map(n => n.cloneNode(true));
  }
  function restoreChildren(el, snapshot) {
    while (el.firstChild) el.removeChild(el.firstChild);
    snapshot.forEach(n => el.appendChild(n));
  }

  function tryInjectMenuItem() {
    if (injected && document.querySelector('[data-hutech-xlsx-export]')) return;
    const exportAll = document.querySelector('[data-menu-id="export-all"]');
    if (!exportAll) return;
    // Find parent <li> (MenuItem)
    const menuItem = exportAll.closest('[role="menuitem"], li');
    if (!menuItem) return;

    // Avoid duplicate
    const existing = menuItem.parentNode && menuItem.parentNode.querySelector('[data-hutech-xlsx-export]');
    if (existing) return;

    const clone = menuItem.cloneNode(true);
    clone.setAttribute('data-hutech-xlsx-export', '1');
    // Remove disabled state
    clone.removeAttribute('aria-disabled');
    clone.classList.remove('disabled');

    // Rename id + aria-labelledby pair để tránh duplicate id (HTML spec violation
    // + a11y break vì aria-labelledby trỏ về element gốc).
    const uniqSuffix = '-hutech-xlsx-' + Date.now().toString(36);
    const labelledBy = clone.getAttribute('aria-labelledby');
    if (labelledBy) {
      const newLabelledBy = labelledBy + uniqSuffix;
      clone.setAttribute('aria-labelledby', newLabelledBy);
      const target = clone.querySelector('#' + CSS.escape(labelledBy));
      if (target) target.id = newLabelledBy;
    }
    // Defensive: rename mọi id còn lại trong clone (đề phòng nested duplicates).
    clone.querySelectorAll('[id]').forEach(el => {
      el.id = el.id + uniqSuffix;
    });
    // Replace inner label — XSS-safe via DOM API
    const i18n = (window.HUTECH && window.HUTECH.i18n && window.HUTECH.i18n.t) || (k => k);
    const label = i18n('xlsx.menu.label');
    const innerSpan = clone.querySelector('[data-menu-id]');
    if (innerSpan) {
      innerSpan.setAttribute('data-menu-id', 'export-xlsx-hutech');
      buildLabelContent(innerSpan, ICON_SVG, label);
    } else {
      buildLabelContent(clone, ICON_SVG, label);
    }

    // Strip out existing event handlers by replacing element with fresh clone
    const fresh = clone.cloneNode(true);

    // InstUI Menu manage highlight state qua JS — sync với chúng ta:
    // mouseenter → clear highlighted state ở siblings.
    fresh.addEventListener('mouseenter', function () {
      const siblings = (fresh.parentNode && fresh.parentNode.querySelectorAll('[role="menuitem"]')) || [];
      siblings.forEach(item => {
        if (item === fresh) return;
        // Dispatch synthetic mouseleave để InstUI cleanup highlighted state.
        item.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true }));
        // Defense in depth: remove common highlight class names.
        Array.from(item.classList).forEach(cls => {
          if (/(hover|highlight|focused|selected|active)/i.test(cls)) {
            item.classList.remove(cls);
          }
        });
      });
    });

    fresh.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        const labelEl = fresh.querySelector('[data-menu-id]') || fresh;
        const originalChildren = snapshotChildren(labelEl);
        const i18nClick = (window.HUTECH && window.HUTECH.i18n && window.HUTECH.i18n.t) || (k => k);
        buildLabelContent(labelEl, ICON_SVG, i18nClick('xlsx.menu.exporting'));
        startExportAndDownload(true)
          .then(() => {
            restoreChildren(labelEl, originalChildren);
          })
          .catch(err => {
            console.error(TAG, 'export fail:', err);
            buildLabelContent(labelEl, ICON_SVG, i18nClick('xlsx.menu.error'));
            setTimeout(() => {
              restoreChildren(labelEl, originalChildren);
            }, 4000);
          });
      },
      true,
    );

    menuItem.parentNode.insertBefore(fresh, menuItem.nextSibling);
    injected = true;
    console.log(TAG, 'menu item injected after Export Entire Gradebook');
  }

  // Watch for menu render (Action dropdown opens on click → menu appears in DOM)
  const observer = new MutationObserver(() => {
    tryInjectMenuItem();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial try
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInjectMenuItem);
  } else {
    tryInjectMenuItem();
  }

  console.log(TAG, 'Gradebook XLSX export loaded');
})();

// ─── hutech-brand.js ───
// HUTECH Canvas — Brand polish Custom JS
// File: hutech-brand.js
// Refs: Track B §5.4 (footer copyright) + B2 gap (privacy_policy_url override)
//
// Scope:
//   - Inject "© HUTECH" copyright into footer
//   - Override `data-privacy-policy-url` on login form (Canvas hardcodes canvaslms.com)
//
// NO rewriteTitle (Track B §5.2) — Track A i18n already rebrand title via
// vi_hutech.yml. Verify smoke "Đăng nhập vào HUTECH LMS" OK → JS rewrite not needed.
//
// Kill switch: ?disable_hutech_js=1

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) {
    console.log('[HUTECH-brand] disabled via kill switch');
    return;
  }

  const TAG = '[HUTECH-brand]';
  const { t: i18n } = window.HUTECH.i18n;

  // URL HUTECH — Mạnh review before deploy prod (may change)
  const HUTECH_PRIVACY_URL = 'https://hutech.edu.vn/privacy';

  // --- Override data-privacy-policy-url on login form ---
  // Canvas Rails view hardcodes `data-privacy-policy-url="http://www.canvaslms.com/policies/privacy-policy"`
  // on <div id="new_login_data">. Override before React component mounts + renders link.
  function overridePrivacyUrl() {
    const loginData = document.getElementById('new_login_data');
    if (!loginData) return;
    const current = loginData.getAttribute('data-privacy-policy-url');
    if (current && current.includes('canvaslms.com')) {
      loginData.setAttribute('data-privacy-policy-url', HUTECH_PRIVACY_URL);
      console.log(TAG, 'privacy_policy_url overridden:', current, '→', HUTECH_PRIVACY_URL);
    }
  }

  // --- Rebrand login welcome heading: "Chào mừng bạn đến với Canvas" → HUTECH LMS ---
  // Canvas i18n key fixed = "Canvas" literal. Custom JS rewrite h1[data-cid="Heading"]
  // trên login pages khi text chứa "Canvas". React render async → MutationObserver.
  const REBRANDED = Symbol('hutech-login-welcome-rebranded');
  function rebrandLoginWelcome() {
    document.querySelectorAll('h1[data-cid="Heading"]').forEach(h => {
      if (h[REBRANDED]) return;
      const txt = (h.textContent || '').trim();
      if (!txt) return;
      // Match cả vi + en + variants
      if (/Canvas/i.test(txt) && /(chào mừng|welcome)/i.test(txt)) {
        h.textContent = i18n('brand.loginWelcome');
        h[REBRANDED] = true;
        console.log(TAG, 'login welcome rebranded:', txt, '→', h.textContent);
      }
    });
  }

  // --- Inject HUTECH copyright into footer ---
  // Footer element renders ~600ms after page load (Canvas lazy). Retry 2 times.
  function injectCopyright() {
    if (document.getElementById('hutech-footer-copyright')) return;
    const footer = document.querySelector('#footer, .ic-app-footer, footer');
    if (!footer) return;
    const span = document.createElement('span');
    span.id = 'hutech-footer-copyright';
    span.style.cssText = 'color: rgba(39, 39, 39, 0.7); font-size: 12px; margin-left: 12px;';
    span.textContent = i18n('brand.footerCopyright');
    footer.appendChild(span);
  }

  // --- Run sequence ---
  function run() {
    overridePrivacyUrl();
    injectCopyright();
    rebrandLoginWelcome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Retry footer + welcome 2 lần để catch lazy render (React hydration ~600ms)
  setTimeout(() => {
    injectCopyright();
    rebrandLoginWelcome();
  }, 1500);
  setTimeout(() => {
    injectCopyright();
    rebrandLoginWelcome();
  }, 3500);

  // MutationObserver: cover SPA re-render
  const mo = new MutationObserver(rebrandLoginWelcome);
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

// ─── hutech-login.js ───
// HUTECH Canvas — Login enhancements (legacy login .ic-Login)
// File: hutech-login.js
// Scope (chỉ chạy trên trang login):
//   - Chèn tiêu đề + phụ đề HUTECH dưới logo
//   - Chèn divider "hoặc đăng nhập bằng" trước nút SSO Gmail
//   - Nút hiện/ẩn mật khẩu (👁) cho ô password
// Styling: hutech-login.css. Text: HUTECH.i18n (i18n/vi.json key 'login.*').
// Kill switch: ?disable_hutech_js=1

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) return;

  // Chỉ chạy trên legacy login page
  if (!document.body || !document.body.classList.contains('ic-Login-Body')) return;

  const TAG = '[HUTECH-login]';
  const { h } = window.HUTECH.dom;
  const { t: i18n } = window.HUTECH.i18n;
  const SVG_NS = 'http://www.w3.org/2000/svg';

  // SVG icon eye / eye-off (Material) — build qua createElementNS (no innerHTML)
  const EYE = 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17a5 5 0 110-10 5 5 0 010 10zm0-8a3 3 0 100 6 3 3 0 000-6z';
  const EYE_OFF = 'M12 7a5 5 0 015 5c0 .65-.13 1.26-.36 1.83l2.92 2.92A11.8 11.8 0 0023 12c-1.73-4.39-6-7.5-11-7.5-1.27 0-2.49.2-3.64.57l2.17 2.17C11.74 7.13 11.86 7 12 7zM2 4.27l2.28 2.28.46.46A11.8 11.8 0 001 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65a3 3 0 003 3c.22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53a5 5 0 01-5-5c0-.79.2-1.53.53-2.2z';

  function svgEye(d) {
    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', d);
    svg.appendChild(path);
    return svg;
  }

  // --- 1. Tiêu đề + phụ đề ---
  function injectTitle() {
    const header = document.querySelector('.ic-Login-header');
    if (!header || header.querySelector('.hutech-login__title')) return;
    header.appendChild(h('div', { class: 'hutech-login__title' }, [i18n('login.title')]));
    header.appendChild(h('div', { class: 'hutech-login__subtitle' }, [i18n('login.subtitle')]));
  }

  // --- 2. Divider trước nút SSO ---
  function injectDivider() {
    const sso = document.querySelector('.ic-Login__sso');
    if (!sso || document.querySelector('.hutech-login__divider')) return;
    sso.parentNode.insertBefore(
      h('div', { class: 'hutech-login__divider' }, [i18n('login.divider')]),
      sso
    );
  }

  // --- 3. Nút hiện/ẩn mật khẩu ---
  function injectPasswordToggle() {
    const input = document.getElementById('pseudonym_session_password');
    if (!input || input.parentNode.querySelector('.hutech-login__pwd-toggle')) return;
    const wrap = input.parentNode; // .ic-Form-control--login
    wrap.classList.add('hutech-login__pwd-wrap');

    const icon = svgEye(EYE);
    const btn = h('button', {
      type: 'button',
      class: 'hutech-login__pwd-toggle',
      'aria-label': i18n('login.pwd.show'),
      title: i18n('login.pwd.show'),
      onClick: function () {
        const showing = input.type === 'text';
        input.type = showing ? 'password' : 'text';
        const label = showing ? i18n('login.pwd.show') : i18n('login.pwd.hide');
        btn.setAttribute('aria-label', label);
        btn.setAttribute('title', label);
        btn.replaceChild(svgEye(showing ? EYE : EYE_OFF), btn.firstChild);
      },
    }, [icon]);

    wrap.appendChild(btn);
  }

  // --- 4. Honeycomb lục giác nền (giống UEF) ---
  // Lục giác flat-top SÁT NHAU (cạnh s=54) phủ kín viewBox 1600×900, fill trắng
  // opacity ngẫu nhiên; ~45% ô pulse opacity về 0 rồi quay lại (CSS .hx-anim).
  function injectHexBg() {
    if (document.querySelector('.hutech-login__hex')) return;
    const W = 1600, H = 900, s = 50;
    const colSpacing = 1.5 * s;
    const rowSpacing = Math.sqrt(3) * s;

    const svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.setAttribute('aria-hidden', 'true');

    let col = 0;
    for (let cx = -s; cx <= W + s; cx += colSpacing) {
      const offY = (col % 2) ? rowSpacing / 2 : 0;
      for (let cy = -s + offY; cy <= H + s; cy += rowSpacing) {
        const pts = [];
        for (let i = 0; i < 6; i++) {
          const a = Math.PI / 3 * i; // flat-top: bước 60°
          pts.push((cx + s * Math.cos(a)).toFixed(1) + ',' + (cy + s * Math.sin(a)).toFixed(1));
        }
        const poly = document.createElementNS(SVG_NS, 'polygon');
        poly.setAttribute('points', pts.join(' '));
        if (Math.random() < 0.45) {
          // ô "đổi màu theo thời gian": ruột (fill) pulse về 0 rồi quay lại,
          // đỉnh sáng cao hơn → tương phản sáng/tối rõ
          const base = 0.22 + Math.random() * 0.30; // đỉnh fill-opacity 0.22–0.52 (sáng đậm)
          poly.setAttribute('class', 'hx-anim');
          poly.setAttribute('fill-opacity', base.toFixed(3));
          poly.style.setProperty('--hx-o', base.toFixed(3));
          poly.style.setProperty('--hx-d', (4 + Math.random() * 4).toFixed(1) + 's'); // 4–8s nhanh hơn
          poly.style.setProperty('--hx-b', '-' + (Math.random() * 12).toFixed(1) + 's'); // desync
        } else {
          // ô tĩnh: HOÀN TOÀN trong suốt → nhìn xuyên thấu nền phía sau (chỉ viền hiện)
          poly.setAttribute('fill-opacity', '0');
        }
        svg.appendChild(poly);
      }
      col++;
    }

    const box = document.createElement('div');
    box.className = 'hutech-login__hex';
    box.appendChild(svg);
    document.body.appendChild(box);
  }

  function run() {
    try {
      injectHexBg();
      injectTitle();
      injectDivider();
      injectPasswordToggle();
    } catch (e) {
      console.warn(TAG, 'error:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Retry phòng Canvas login.js render lại form (forgot-password toggle)
  setTimeout(run, 1200);

  console.log(TAG, 'loaded');
})();

// ─── pdf-preview-fallback.js ───
// HUTECH Canvas — PDF preview fallback for self-hosted (no Canvadocs)
// Mục đích: SpeedGrader + Files browser → inject iframe PDF browser native
// thay cho Canvadocs cloud service (không hoạt động ở self-hosted).
//
// Cover: PDF only (~70-80% submission HUTECH SĐH). DOCX/PPTX/XLSX cần OnlyOffice
// (Track E layer 2 — chưa deploy).
//
// Apply: paste vào Account → Themes → Custom JS (Theme Editor admin UI)
// hoặc deploy script: ./scripts/deploy-customization.sh staging
// Kill switch: ?disable_hutech_js=1 trên URL
// Debug: window.HUTECH_PDF_DEBUG = true → verbose log
// Repo source: infra/customization/custom-js/pdf-preview-fallback.js

(function () {
  'use strict';

  if (window.HUTECH_DISABLE === true || window.location.search.includes('disable_hutech_js')) {
    console.log('[HUTECH-PDF] disabled via kill switch');
    return;
  }

  const TAG = '[HUTECH-PDF]';
  // Cache-bust viewer assets (html/js/css). Bump khi đổi viewer hoặc PDF.js core.
  const HPV_VERSION = '20260622a';
  const IFRAME_CLASS = 'hutech-pdf-fallback-iframe';
  const DEBUG = () => window.HUTECH_PDF_DEBUG === true;

  function dlog(...args) { if (DEBUG()) console.log(TAG, ...args); }
  function ilog(...args) { console.log(TAG, ...args); }

  // --- Helpers ---

  // Lấy URL preview Canvas chuẩn. Ưu tiên:
  // 1. fullHref đã có sẵn từ findPdfFromSubmissionFilesList (Canvas đã substitute templated)
  // 2. Build từ template hidden form + submissionId + attachmentId
  // 3. Fallback /files/<id>/download?inline=1
  // Format đúng: /courses/X/assignments/Y/submissions/<sid>?download=<aid>&inline=1
  function previewUrlForAttachment(attachmentId, submissionId, fullHref) {
    if (fullHref && !fullHref.includes('{{')) return fullHref;
    try {
      const hidden = document.querySelector('#submission_file_hidden .display_name');
      if (hidden?.href) {
        let src = decodeURIComponent(hidden.href);
        src = src.replace('{{submissionId}}', submissionId || '');
        src = src.replace('{{anonymousId}}', submissionId || '');
        src = src.replace('{{attachmentId}}', attachmentId);
        if (!src.includes('{{')) return src;
      }
    } catch (e) {
      console.warn(TAG, 'previewUrlForAttachment template error:', e);
    }
    // KHÔNG truyền download_frd=0 — Ruby params['download_frd']='0' là TRUTHY → fall
    // to attachment disposition. Bỏ hẳn param thì !params[:download_frd] = true → inline.
    return `/files/${attachmentId}/download?inline=1`;
  }

  function downloadUrlForAttachment(attachmentId) {
    return `/files/${attachmentId}/download?download_frd=1`;
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[<>&"']/g, c => ({
      '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  // --- PDF detection (multiple paths because Canvas data structures vary) ---

  function findPdfFromEG() {
    try {
      if (!window.EG?.currentStudent) return null;
      const sub = window.EG.currentStudent.submission;
      if (!sub) return null;
      dlog('EG.currentStudent.submission keys:', Object.keys(sub));
      const submissionId = sub.id || sub.anonymous_id;

      // Path A: versioned_attachments (most common)
      const va = sub.versioned_attachments || [];
      for (const item of va) {
        const a = item.attachment || item;
        if (a?.content_type === 'application/pdf' && a.id) {
          return { id: a.id, name: a.display_name || a.filename || 'submission.pdf', submissionId };
        }
      }

      // Path B: attachments
      const ats = sub.attachments || [];
      for (const a of ats) {
        if (a?.content_type === 'application/pdf' && a.id) {
          return { id: a.id, name: a.display_name || a.filename || 'submission.pdf', submissionId };
        }
      }

      // Path C: single attachment
      if (sub.attachment?.content_type === 'application/pdf' && sub.attachment.id) {
        return { id: sub.attachment.id, name: sub.attachment.display_name || 'submission.pdf', submissionId };
      }

      // Path D: attachment_id only
      if (sub.attachment_id) {
        return { id: sub.attachment_id, name: 'submission.pdf', submissionId };
      }

      dlog('EG submission has no PDF attachment');
    } catch (e) {
      console.warn(TAG, 'findPdfFromEG error:', e);
    }
    return null;
  }

  function findPdfFromSubmissionFilesList() {
    // Canvas SpeedGrader clone #submission_file_hidden vào #submission_files_list cho mỗi file.
    // Mỗi clone:
    //   - <a class="display_name" href="/courses/X/assignments/Y/submissions/Z?download=ID&inline=1">filename</a>
    //   - jQuery .data('attachment', attachmentObj) gắn attachment object
    // Source: ui/features/speed_grader/jquery/speed_grader.tsx renderSubmissionFiles
    try {
      const links = document.querySelectorAll(
        '#submission_files_list a.display_name, #submission_files_container a.display_name'
      );
      for (const link of links) {
        if (link.closest('#submission_file_hidden')) continue;  // skip template
        const href = link.getAttribute('href') || '';
        if (href.includes('{{')) continue;  // unfilled template
        const m = href.match(/[?&]download=(\d+)/) || href.match(/\/files\/(\d+)/);
        if (!m) continue;
        const attId = m[1];
        const name = (link.textContent || link.getAttribute('title') || '').trim();
        // Heuristic PDF: filename ends .pdf, OR jQuery data attachment content_type
        let isPdf = /\.pdf$/i.test(name);
        if (!isPdf && window.jQuery) {
          try {
            const att = window.jQuery(link).data('attachment');
            if (att?.content_type === 'application/pdf') isPdf = true;
          } catch (e) { /* ignore */ }
        }
        if (isPdf) {
          // Extract submissionId from URL: /submissions/{id}?...
          const sm = href.match(/\/submissions\/([^/?&]+)/);
          const submissionId = sm ? sm[1] : null;
          return { id: attId, name: name || 'submission.pdf', submissionId, fullHref: href };
        }
      }
      dlog('submission_files_list has no PDF link');
    } catch (e) {
      console.warn(TAG, 'findPdfFromSubmissionFilesList error:', e);
    }
    return null;
  }

  function findPdfFromHiddenForm() {
    // Legacy stub — không dùng template trực tiếp (có {{}})
    return null;
  }

  function findPdfAttachment() {
    return findPdfFromEG() || findPdfFromSubmissionFilesList() || findPdfFromHiddenForm();
  }

  // --- DOM detection ---

  function findIframeHolder() {
    // Canvas SpeedGrader DOM ID: #iframe_holder (verified Canvas 2025-12-03+)
    return document.querySelector('#iframe_holder');
  }

  function isHolderActive(holder) {
    if (!holder) return false;
    // Holder shown when SpeedGrader displays preview
    // Hidden when no submission selected
    const style = window.getComputedStyle(holder);
    return style.display !== 'none';
  }

  // --- Fallback render ---

  function renderFallback(holder, pdf) {
    if (holder.querySelector('.' + IFRAME_CLASS)) {
      dlog('fallback already rendered, skip');
      return;
    }

    const previewUrl = previewUrlForAttachment(pdf.id, pdf.submissionId, pdf.fullHref);
    ilog('rendering PDF fallback for attachment', pdf.id, pdf.name, 'src=', previewUrl);

    holder.innerHTML = '';
    holder.style.position = 'relative';
    // Full available viewport height — minus holder offset top (Canvas header)
    // minus small buffer (16px) để không cắt scrollbar. Fallback 600px nếu compute fail.
    const setHolderHeight = () => {
      try {
        const top = holder.getBoundingClientRect().top;
        const avail = Math.max(400, window.innerHeight - top - 16);
        holder.style.height = `${avail}px`;
      } catch {
        holder.style.height = '600px';
      }
    };
    setHolderHeight();
    // Re-compute on window resize (debounce)
    let resizeTimer;
    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setHolderHeight, 100);
    };
    window.addEventListener('resize', onResize);
    // Cleanup khi holder unmount (mutation observer)
    const mo = new MutationObserver(() => {
      if (!document.body.contains(holder)) {
        window.removeEventListener('resize', onResize);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // PDF iframe — TRÌNH XEM PDF.JS TÙY BIẾN HUTECH (style template HUTECH).
    // Fallback về trình xem native của trình duyệt: thêm ?hutech_pdf_native=1 vào URL.
    const HUTECH_PDF_VIEWER = '/hutech-customization/pdfjs/hutech-pdf-viewer.html';
    const useNative = window.location.search.includes('hutech_pdf_native');
    const viewerSrc = useNative
      ? previewUrl
      : HUTECH_PDF_VIEWER + '?file=' + encodeURIComponent(previewUrl) +
        '&name=' + encodeURIComponent(pdf.name || 'document.pdf') + '&_v=' + HPV_VERSION;
    const iframe = document.createElement('iframe');
    iframe.className = IFRAME_CLASS;
    iframe.src = viewerSrc;
    iframe.style.cssText = 'width:100%;height:100%;border:none;display:block;';
    iframe.setAttribute('aria-label', 'Xem trước PDF bài nộp');
    iframe.setAttribute('title', pdf.name);
    holder.appendChild(iframe);

    holder.style.display = 'block';
  }

  // --- Detection of failed Canvas preview ---

  function isCanvasPreviewFailed(holder) {
    if (!holder) return false;
    // Indicators:
    // 1. #no_annotation_warning visible — Canvas shows this when canvadoc missing
    const warn = document.querySelector('#no_annotation_warning');
    if (warn && window.getComputedStyle(warn).display !== 'none') return true;
    // 2. Holder empty or contains broken iframe (no src)
    const iframe = holder.querySelector('iframe:not(.' + IFRAME_CLASS + ')');
    if (iframe && (!iframe.src || iframe.src === 'about:blank')) return true;
    // 3. Holder text contains failure phrase (Vietnamese or English)
    const text = holder.textContent || '';
    if (text.includes('Chú thích không có sẵn') || text.includes('annotations are not available')) return true;
    // 4. Empty holder + no iframe yet but PDF should be there
    if (holder.children.length === 0) {
      // Empty — likely Canvas waiting for canvadoc that won't come
      return true;
    }
    return false;
  }

  // --- Main entry ---

  let lastFixedFor = null;  // attachment_id of last successful fix
  let lastDiagLog = '';  // avoid spamming same diag line

  function diagSpeedGrader() {
    const isPath = /\/speed_grader/.test(window.location.pathname);
    const holder = findIframeHolder();
    const eg = window.EG;
    const sub = eg?.currentStudent?.submission;
    const subKeys = sub ? Object.keys(sub).slice(0, 5).join(',') : '(none)';
    // Inspect #submission_files_list
    const fileLinks = document.querySelectorAll('#submission_files_list a.display_name, #submission_files_container a.display_name');
    const visibleLinks = [...fileLinks].filter(l => !l.closest('#submission_file_hidden'));
    const filesInfo = visibleLinks.map(l => {
      const h = l.getAttribute('href') || '';
      const m = h.match(/[?&]download=(\d+)/);
      return `${(l.textContent || '').trim().slice(0, 30)}=>${m ? m[1] : 'no-id'}`;
    }).join('|') || '(empty)';
    const pdf = findPdfAttachment();
    const failed = holder ? isCanvasPreviewFailed(holder) : null;
    return `path=${isPath} holder=${!!holder} EG=${!!eg} files=[${filesInfo}] pdf=${pdf ? `${pdf.id} src=${pdf.fullHref?.slice(0, 80)}` : '(none)'} failed=${failed}`;
  }

  function trySpeedGraderFix() {
    if (!/\/speed_grader/.test(window.location.pathname)) return false;

    // Diag — print 1 lần mỗi state change để user thấy
    const diag = diagSpeedGrader();
    if (diag !== lastDiagLog) {
      ilog('diag:', diag);
      lastDiagLog = diag;
    }

    const holder = findIframeHolder();
    if (!holder) return false;

    const pdf = findPdfAttachment();
    if (!pdf) return false;

    if (lastFixedFor === pdf.id && holder.querySelector('.' + IFRAME_CLASS)) {
      return true;
    }

    renderFallback(holder, pdf);
    lastFixedFor = pdf.id;
    return true;
  }

  function tryFilesPagePdf() {
    const m = window.location.pathname.match(/\/files\/(\d+)(?:\/preview)?\/?$/);
    if (!m) return false;
    const id = m[1];

    const preview = document.querySelector('#doc_preview, .file_preview, #content .ic-app-main-content');
    if (!preview) return false;
    if (preview.querySelector('.' + IFRAME_CLASS)) return true;

    // Only act if there's a failure indicator
    if (!isCanvasPreviewFailed(preview)) return false;

    renderFallback(preview, { id, name: 'Tài liệu' });
    return true;
  }

  // --- Chiếm #doc_preview (trang xem file/SpeedGrader doc_preview) ---
  // Canvas render PDF non-canvadoc vào #doc_preview qua loadDocPreview (native).
  // Ta đọc data-attachment_id + data-mimetype → render THẲNG viewer HUTECH vào đó,
  // KHÔNG đợi lỗi (proactive). Re-assert nếu Canvas dựng lại (mất .IFRAME_CLASS).
  function tryDocPreview() {
    const dps = document.querySelectorAll('#doc_preview, .doc_preview, [data-mimetype]');
    let acted = false;
    dps.forEach(dp => {
      const mime = dp.getAttribute('data-mimetype') || '';
      const name = dp.getAttribute('data-attachment_name') ||
                   dp.getAttribute('data-attachment-name') || 'Tài liệu';
      const aid = dp.getAttribute('data-attachment_id') ||
                  dp.getAttribute('data-attachment-id');
      if (!aid) return;
      if (!/pdf/i.test(mime) && !/\.pdf(\b|$)/i.test(name)) return;
      if (dp.querySelector('.' + IFRAME_CLASS)) { acted = true; return; }  // đã có viewer
      renderFallback(dp, { id: aid, name });
      ilog('chiếm #doc_preview → viewer HUTECH: id=', aid, 'mime=', mime);
      acted = true;
    });
    return acted;
  }

  // --- Universal File Preview Iframe handler ---
  // Covers MỌI Canvas surface render iframe.ef-file-preview-frame:
  //   - Course Files preview page: /courses/<id>/files?preview=<file_id> (Issue #73)
  //   - Standalone File show:      /files/<id>, /files/<id>/preview
  //   - File Preview Overlay:      bất kỳ page nào (Assignment/Page/Discussion/
  //                                 Announcement/Quiz/Module) khi user click link
  //                                 RCE `a.instructure_file_link[inline_disabled]`
  //                                 → Canvas postMessage 'preview_file' → mở overlay
  //                                 với #file_preview_container > iframe.ef-file-preview-frame
  //
  // Self-hosted không có Canvadocs → iframe src thường là Canvas internal
  // `/files/<id>/file_preview?annotate=0` hoặc canvadoc URL → fail.
  // Swap src → /files/<id>/download?inline=1 cho browser PDF viewer.
  let lastFilesDiag = '';
  function tryFilePreviewIframe() {
    // Files v1 legacy: class="ef-file-preview-frame"
    // Files v2 (new):   id="file-preview-iframe"
    const iframes = document.querySelectorAll(
      'iframe.ef-file-preview-frame, #file-preview-iframe'
    );

    // Diag (avoid spam)
    if (iframes.length > 0) {
      const diag = `file-preview iframes=${iframes.length} patched=${
        [...iframes].filter(f => f.dataset.hutechPatched === '1').length
      }`;
      if (diag !== lastFilesDiag) {
        ilog(diag);
        lastFilesDiag = diag;
      }
    }

    let anyPatched = false;
    iframes.forEach(iframe => {
      if (iframe.dataset.hutechPatched === '1') return;

      const src = iframe.getAttribute('src') || '';
      if (!src) return;  // chưa load src, chờ lần tiếp

      // Skip nếu đã là viewer HUTECH (của ta). Chỉ ở chế độ native
      // (?hutech_pdf_native=1) thì /download?inline=1 mới coi là của ta.
      const nativeMode = window.location.search.includes('hutech_pdf_native');
      if (src.includes('hutech-pdf-viewer.html') ||
          (nativeMode && src.includes('/download') && src.includes('inline=1'))) return;

      // --- Extract file_id (multi-source) ---
      let fileId = null;
      // 1) Từ src: /files/<id>/file_preview, /api/v1/files/<id>, /canvadoc_session/<...>
      const srcMatch = src.match(/\/(?:api\/v1\/)?files\/(\d+)/);
      if (srcMatch) fileId = srcMatch[1];
      // 2) Từ URL search ?preview=<id> (Course Files page)
      if (!fileId) {
        const previewId = new URLSearchParams(window.location.search).get('preview');
        if (previewId) fileId = previewId;
      }
      // 3) Từ pathname /files/<id> (File show page)
      if (!fileId) {
        const pathMatch = window.location.pathname.match(/\/files\/(\d+)/);
        if (pathMatch) fileId = pathMatch[1];
      }
      // 4) Từ parent data-file-id (overlay container có thể set)
      if (!fileId) {
        const dataEl = iframe.closest('[data-file-id]');
        if (dataEl && dataEl.dataset.fileId) fileId = dataEl.dataset.fileId;
      }

      if (!fileId) {
        dlog('cannot determine file_id for iframe, src=', src.slice(0, 100));
        return;
      }

      // Mặc định: nhúng TRÌNH XEM PDF.JS TÙY BIẾN HUTECH (style template HUTECH).
      // Fallback trình xem native của trình duyệt: thêm ?hutech_pdf_native=1 vào URL trang.
      const pdfUrl = `/files/${fileId}/download?inline=1`;
      const useNativeViewer = window.location.search.includes('hutech_pdf_native');
      const fallbackUrl = useNativeViewer
        ? `${pdfUrl}#toolbar=1&navpanes=1&view=FitH`
        : `/hutech-customization/pdfjs/hutech-pdf-viewer.html?file=${encodeURIComponent(pdfUrl)}&_v=${HPV_VERSION}`;

      // CSS đã hide iframe (visibility:hidden) until .hutech-pdf-shown class.
      // Show spinner overlay TRƯỚC khi swap src.
      iframe.classList.remove('hutech-pdf-shown');
      showSpinnerForIframe(iframe);

      // KHÔNG replace element (React managed DOM — replaceChild → NotFoundError).
      iframe.removeAttribute('sandbox');
      iframe.setAttribute('src', fallbackUrl);
      iframe.dataset.hutechPatched = '1';
      iframe.dataset.hutechFileId = fileId;

      // On load: show iframe (CSS reveal) + hide spinner
      iframe.addEventListener('load', () => {
        iframe.classList.add('hutech-pdf-shown');
        const container = iframe.closest('.ef-file-preview-container');
        if (container) container.classList.add('hutech-pdf-ready');
        hideSpinnerForIframe(iframe);
      }, { once: true });

      // Watch iframe src changes (Canvas slider click → updates src directly)
      attachIframeSrcObserver(iframe);

      ilog('file-preview iframe patched: id=', fileId,
           ' oldSrc=', src.slice(0, 60), ' newSrc=', fallbackUrl);
      anyPatched = true;
    });
    return anyPatched;
  }

  // --- Universal: ÉP MỌI view PDF native → viewer HUTECH (bỏ hết mặc định) ---
  // Bắt embed/object[type=application/pdf] + iframe trỏ THẲNG tới PDF (Canvas tự
  // render bằng trình duyệt). Dedupe theo file-id: nếu PDF đó đã có viewer HUTECH
  // trên trang → ẩn bản native trùng; nếu chưa → thay nó bằng viewer HUTECH.
  function buildViewerSrc(pdfUrl) {
    if (window.location.search.includes('hutech_pdf_native')) return pdfUrl;
    return '/hutech-customization/pdfjs/hutech-pdf-viewer.html?file=' +
      encodeURIComponent(pdfUrl) + '&_v=' + HPV_VERSION;
  }
  function pdfFileIdOf(url) {
    const u = url || '';
    // 1) URL thường (/files/33/) lẫn đã encode (files%2F33)
    let m = u.match(/files(?:%2F|\/)(\d+)/i);
    if (m) return m[1];
    // 2) Preview bài nộp: /submissions/Z?download=<file_id>&inline=1
    m = u.match(/[?&]download=(\d+)/);
    if (m) return m[1];
    return null;
  }
  function nativePdfUrl(el) {
    const raw = el.getAttribute('src') || el.getAttribute('data') || '';
    if (!raw || raw.includes('hutech-pdf-viewer.html')) return null;
    const type = (el.getAttribute('type') || '').toLowerCase();
    const looksPdf =
      type === 'application/pdf' ||
      /\/files\/\d+\/(?:download|inline_view|file_preview|preview)/i.test(raw) ||
      // Submission PDF CHỈ tin khi có download=<file_id> (dòng dưới đã lo).
      // BỎ ?preview=/?inline= của submission: #preview_frame dùng src
      // /submissions/Z?preview=1 cho MỌI loại bài nộp (external_tool, text...) →
      // trả HTML, KHÔNG phải PDF. Ép viewer lên nó = "Invalid PDF structure".
      /[?&]download=\d+/i.test(raw) ||
      /\.pdf(?:[?#]|$)/i.test(raw) ||
      /canvadoc|docviewer|inline_view|file_preview/i.test(raw);
    return looksPdf ? raw : null;
  }
  // Container đang chứa viewer HUTECH (để ẩn MỌI render PDF native cùng vùng,
  // không lệ thuộc khớp URL — vd SpeedGrader nhét thêm iframe native cạnh viewer).
  function hutechViewerContainers() {
    const SEL = '#iframe_holder, .ef-file-preview-container, .ef-file-preview-stretch, ' +
      '#doc_preview, #submission_preview, .submission_preview';
    const list = [];
    document.querySelectorAll('iframe[src*="hutech-pdf-viewer.html"], .' + IFRAME_CLASS)
      .forEach(v => { const c = v.closest(SEL) || v.parentElement; if (c) list.push(c); });
    return list;
  }
  function existingViewerFileIds() {
    const ids = new Set();
    document.querySelectorAll('iframe[src*="hutech-pdf-viewer.html"]').forEach(fr => {
      const src = fr.getAttribute('src') || '';
      // decode tham số file= để trích được file-id (vd submissions?download=33)
      const fm = src.match(/[?&]file=([^&]+)/);
      let inner = src;
      if (fm) { try { inner = decodeURIComponent(fm[1]); } catch { inner = fm[1]; } }
      const id = pdfFileIdOf(inner);
      if (id) ids.add(id);
    });
    return ids;
  }
  function convertNativePdfViews() {
    const els = document.querySelectorAll(
      'embed[type="application/pdf"], object[type="application/pdf"], ' +
      'embed[src], object[data], iframe[src]'
    );
    let any = false;
    const seen = existingViewerFileIds();         // file-id đã có viewer HUTECH
    const viewerContainers = hutechViewerContainers();
    els.forEach(el => {
      if (el.dataset.hutechPatched === '1') return;
      // không đụng phần tử bên trong chính viewer HUTECH
      if (el.closest('.' + IFRAME_CLASS)) return;
      const pdfUrl = nativePdfUrl(el);
      if (!pdfUrl) return;

      const fileId = pdfFileIdOf(pdfUrl);
      const dupKey = fileId || pdfUrl;
      // Ẩn nếu: (a) đã có viewer HUTECH cho đúng file này, HOẶC
      //         (b) nằm CÙNG VÙNG với một viewer HUTECH (kill native trùng SpeedGrader)
      const inViewerContainer = viewerContainers.some(c => c.contains(el));
      if (seen.has(dupKey) || inViewerContainer) {
        el.dataset.hutechPatched = '1';
        el.style.setProperty('display', 'none', 'important');
        ilog('ẩn view PDF native trùng:', el.tagName, el.id || el.className, '#', dupKey);
        any = true;
        return;
      }
      // ef-file-preview-frame/#file-preview-iframe để tryFilePreviewIframe lo CONVERT
      if (el.matches('iframe.ef-file-preview-frame, #file-preview-iframe')) return;
      seen.add(dupKey);

      const viewerSrc = buildViewerSrc(pdfUrl);
      if (el.tagName === 'IFRAME') {
        el.removeAttribute('sandbox');
        el.setAttribute('src', viewerSrc);
        el.dataset.hutechPatched = '1';
        attachIframeSrcObserver(el);
      } else {
        // embed/object → thay bằng iframe viewer (giữ kích thước nếu có)
        const fr = document.createElement('iframe');
        fr.className = IFRAME_CLASS;
        fr.src = viewerSrc;
        const h = el.getAttribute('height') || el.style.height || '';
        fr.style.cssText = 'width:100%;height:' + (h || '100%') +
          ';min-height:600px;border:none;display:block;';
        fr.dataset.hutechPatched = '1';
        try { el.replaceWith(fr); } catch { el.style.setProperty('display', 'none', 'important'); }
      }
      ilog('view PDF native → viewer HUTECH:', el.tagName, pdfUrl.slice(0, 70));
      any = true;
    });
    return any;
  }

  // Backstop URL-agnostic: trong MỌI container đang có viewer HUTECH, ẩn mọi
  // iframe/embed/object KHÁC (native loadDocPreview/google-viewer/object…) —
  // một vùng đã có viewer HUTECH thì không được phép có khung khác.
  function hideNativeInViewerContainers() {
    let any = false;
    hutechViewerContainers().forEach(c => {
      c.querySelectorAll('iframe, embed, object').forEach(el => {
        if (el.dataset.hutechPatched === '1') return;
        if (el.closest('.' + IFRAME_CLASS)) return;                 // là/trong viewer HUTECH
        const raw = el.getAttribute('src') || el.getAttribute('data') || '';
        if (raw.includes('hutech-pdf-viewer.html')) return;         // chính viewer
        el.dataset.hutechPatched = '1';
        el.style.setProperty('display', 'none', 'important');
        ilog('ẩn khung native cùng vùng viewer:', el.tagName, el.id || el.className,
             'src=', raw.slice(0, 60));
        any = true;
      });
    });
    return any;
  }

  // --- Loading spinner overlay ---
  const SPINNER_CLASS = 'hutech-pdf-spinner-overlay';
  function showSpinnerForIframe(iframe) {
    if (!iframe.parentNode) return;
    // Remove old spinner if any
    iframe.parentNode.querySelectorAll('.' + SPINNER_CLASS).forEach(el => el.remove());
    const ov = document.createElement('div');
    ov.className = SPINNER_CLASS;
    ov.style.cssText = 'position:absolute;inset:0;z-index:5;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.85);pointer-events:none;';
    ov.innerHTML = '<div style="width:48px;height:48px;border:4px solid #0878BE;border-top-color:transparent;border-radius:50%;animation:hutech-pdf-spin 0.8s linear infinite;"></div>';
    // Inject keyframes CSS once
    if (!document.getElementById('hutech-pdf-spinner-style')) {
      const st = document.createElement('style');
      st.id = 'hutech-pdf-spinner-style';
      st.textContent = '@keyframes hutech-pdf-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(st);
    }
    // Container must be positioned
    const parent = iframe.parentNode;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
    parent.appendChild(ov);
  }
  function hideSpinnerForIframe(iframe) {
    if (!iframe.parentNode) return;
    iframe.parentNode.querySelectorAll('.' + SPINNER_CLASS).forEach(el => el.remove());
  }

  // --- MutationObserver: Canvas slider click → update iframe src → re-patch ---
  function attachIframeSrcObserver(iframe) {
    if (iframe.dataset.hutechSrcObserver === '1') return;
    iframe.dataset.hutechSrcObserver = '1';
    const obs = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.attributeName === 'src') {
          const newSrc = iframe.getAttribute('src') || '';
          const nativeMode = window.location.search.includes('hutech_pdf_native');
          const isOurs = newSrc.includes('hutech-pdf-viewer.html') ||
            (nativeMode && newSrc.includes('/download') && newSrc.includes('inline=1'));
          if (!isOurs) {
            ilog('iframe src changed by Canvas:', newSrc.slice(0, 80), '— re-patching');
            iframe.dataset.hutechPatched = '';
            setTimeout(runAll, 50);
          }
        }
      }
    });
    obs.observe(iframe, { attributes: true, attributeFilter: ['src'] });
  }

  // --- Body-level MutationObserver: catch dynamic overlay creation ---
  // Canvas postMessage 'preview_file' → React render #file_preview_container
  // > iframe.ef-file-preview-frame. Observer fires runAll khi iframe target xuất hiện.
  function attachBodyObserver() {
    if (window._hutechBodyObs) return;
    const obs = new MutationObserver(mutations => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          const sel = 'iframe.ef-file-preview-frame, #file-preview-iframe, ' +
            '#doc_preview, [data-mimetype], ' +
            'embed[type="application/pdf"], object[type="application/pdf"], iframe[src]';
          if (node.matches?.(sel) || node.querySelector?.(sel)) {
            clearTimeout(window._hutechBodyDebounce);
            window._hutechBodyDebounce = setTimeout(runAll, 200);
            return;
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    window._hutechBodyObs = obs;
    dlog('body observer attached for overlay iframe creation');
  }

  function runAll() {
    try {
      trySpeedGraderFix();
      tryFilesPagePdf();
      tryDocPreview();
      tryFilePreviewIframe();
      // Quét sau cùng: ép mọi view PDF native còn sót → viewer HUTECH + dọn trùng
      convertNativePdfViews();
      // Backstop: ẩn mọi khung native cùng vùng với viewer HUTECH
      hideNativeInViewerContainers();
    } catch (e) {
      console.warn(TAG, 'runAll error:', e);
    }
  }

  // --- Triggers ---

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(runAll, 500));
  } else {
    setTimeout(runAll, 500);
  }

  // SpeedGrader uses hashchange for student switch
  window.addEventListener('hashchange', () => {
    lastFixedFor = null;
    setTimeout(runAll, 500);
    setTimeout(runAll, 1500);
  });

  // pushState (some Canvas SPA navs)
  const _push = history.pushState;
  history.pushState = function () {
    _push.apply(history, arguments);
    lastFixedFor = null;
    setTimeout(runAll, 500);
    setTimeout(runAll, 1500);
  };
  window.addEventListener('popstate', () => setTimeout(runAll, 800));

  // MutationObserver — Canvas async loads submission JSON sau initial render
  // Watch #iframe_holder for changes; when its content updates, re-evaluate
  let observerAttached = false;
  function attachObserver() {
    if (observerAttached) return;
    const holder = findIframeHolder();
    if (!holder) return;
    const obs = new MutationObserver(() => {
      // Debounce — Canvas may update many times during render
      clearTimeout(window._hutechPdfDebounce);
      window._hutechPdfDebounce = setTimeout(runAll, 300);
    });
    obs.observe(holder, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'src'] });
    observerAttached = true;
    dlog('MutationObserver attached to #iframe_holder');
  }
  setTimeout(attachObserver, 1000);
  setTimeout(attachObserver, 3000);
  // Body observer cho overlay dynamic creation (postMessage 'preview_file')
  if (document.body) attachBodyObserver();
  else document.addEventListener('DOMContentLoaded', attachBodyObserver);

  // Retry interval (catches slow async)
  let attempts = 0;
  const retry = setInterval(() => {
    attempts++;
    runAll();
    attachObserver();
    if (attempts >= 10) {
      clearInterval(retry);
      dlog('retry interval done (10 attempts)');
    }
  }, 1500);

  ilog('PDF preview fallback initialized v2026-05-26-v3 (universal overlay)');
})();

